import {
  AbortOptimizationResponseSchema,
  AddDeliveryTeamManagerRequestSchema,
  AddHubSplitRequestSchema,
  AddHubSplitResponseSchema,
  AdminOrderPartitionDetailSchema,
  AdminOrderPartitionSchema,
  AdminPartitionFulfillmentStatusSchema,
  AdminPartitionFulfillmentTypeSchema,
  AdminPartitionItemSchema,
  AssignDestinationLicenseRequestSchema,
  AssignDestinationLicenseResponseSchema,
  AssignDriverToPartitionRequestSchema,
  AssignDriverToShipmentLegRequestSchema,
  AssignDriverToShipmentLegResponseSchema,
  AssignTaskRequestSchema,
  AssignVehicleRequestSchema,
  AssignVehicleToDriverRequestSchema,
  AuthValidationResponseSchema,
  AutoEnqueueRequestSchema,
  AutoEnqueueResponseSchema,
  B2BWaveOrderProductSummarySchema,
  B2BWaveOrderSummarySchema,
  BatchInsertHubRequestSchema,
  BatchInsertHubResponseSchema,
  BatchRoutesResponseSchema,
  CancelQueueEntryResponseSchema,
  CheckCarrierTrackingMetricsSchema,
  CheckCarrierTrackingResponseSchema,
  CompletionRequirementsSchema,
  CreateAuxiliaryTaskBodySchema,
  CreateAuxiliaryTaskResponseSchema,
  CreateDestinationAddressSchema,
  CreateDestinationRequestSchema,
  CreateDriverRequestSchema,
  CreateDriverVehicleInputSchema,
  CreateHubAddressSchema,
  CreateHubRequestSchema,
  CreateLinkedTasksRequestSchema,
  CreateOnfleetWebhookRequestSchema,
  CreatePartitionTaskRequestSchema,
  CreateRecipientRequestSchema,
  CreateRoutePlanInputSchema,
  CreateShipmentFromPartitionsRequestSchema,
  CreateShipmentFromPartitionsResponseSchema,
  CreateShipmentPlanQueueErrorSchema,
  CreateShipmentPlanRequestSchema,
  CreateShipmentPlanResponseSchema,
  CreateSupplierDriverInputSchema,
  CreateSupplierLocationTeamRequestSchema,
  CreateSupplierVehicleInputSchema,
  CreateTaskRequestSchema,
  CreateTeamRequestSchema,
  CreateVehicleRequestSchema,
  DashboardStatsSchema,
  DeleteShipmentLegRequestSchema,
  DeleteShipmentLegResponseSchema,
  DeleteShipmentRequestSchema,
  DeleteShipmentResponseSchema,
  DeliveryTaskSchema,
  DeliveryTaskStatusSchema,
  DeliveryTaskTypeSchema,
  DeliveryTeamHubOptionSchema,
  DeliveryTeamManagerSchema,
  DestinationAddressSchema,
  DestinationLocationSchema,
  DestinationSchema,
  DispatchShipmentRequestSchema,
  DriverAnalyticsQuerySchema,
  DriverAnalyticsSchema,
  DriverPoolQuerySchema,
  DriverPoolResponseSchema,
  DriverPositionSchema,
  DriverReconcileMetricsSchema,
  DriverSchema,
  DriverStatusSchema,
  DriverTasksQuerySchema,
  EnqueuePartitionRequestSchema,
  EnqueuePartitionResponseSchema,
  EnrichedQueueEntrySchema,
  GeoLocationSchema,
  GetAssignmentQueueStatsQuerySchema,
  GetRoutesQuerySchema,
  GetShipmentDriverPositionsResponseSchema,
  GetShipmentLegManifestResponseSchema,
  GetSupplierRoutesQuerySchema,
  GetTeamTasksQuerySchema,
  HubAddressSchema,
  HubLocationSchema,
  HubSchema,
  InitializeOptimizationRequestSchema,
  InitializeOptimizationResponseSchema,
  InsertWaypointRequestSchema,
  InsertWaypointResponseSchema,
  InternalDatabaseFailoverStatusResponseSchema,
  InternalDatabaseFailoverSwitchResponseSchema,
  InternalDatabaseHealthSchema,
  InternalDatabaseStatusSchema,
  InternalDatabaseSwitchRequestSchema,
  InternalDatabaseSwitchResultSchema,
  LegConsistencyIssueSchema,
  LinkedTasksResponseSchema,
  ListAssignmentQueueQuerySchema,
  ListDestinationsQuerySchema,
  ListDriversQuerySchema,
  ListOrdersQuerySchema,
  ListPartitionsQuerySchema,
  ListRecipientsQuerySchema,
  ListRoutePlansQuerySchema,
  ListShipmentLegQueueQuerySchema,
  ListShipmentSummariesQuerySchema,
  ListSupplierDriversQuerySchema,
  ListSupplierVehiclesQuerySchema,
  ListTasksQuerySchema,
  ListVehiclesQuerySchema,
  OnfleetWebhookSchema,
  OnfleetWebhookTriggerSchema,
  OptimizationIssueSchema,
  OptimizationMetricsSchema,
  OptimizationResultSummarySchema,
  OptimizationStatusResponseSchema,
  OptimizationWorkerMetricsSchema,
  PaginatedPartitionsResponseSchema,
  PartitionTaskResultSchema,
  PartitionTaskSkippedSchema,
  PhotoUploadResponseSchema,
  PollDriverLocationRequestSchema,
  PollDriverLocationResponseSchema,
  PrepareShipmentLegManifestRequestSchema,
  PrepareShipmentLegManifestResponseSchema,
  PrepareShipmentManifestsRequestSchema,
  PrepareShipmentManifestsResponseSchema,
  PublicTrackingResponseSchema,
  QueueListResponseSchema,
  RecipientSchema,
  RecipientSearchQuerySchema,
  ReconcileDriversResponseSchema,
  ReconcileFulfillmentsMetricsSchema,
  ReconcileFulfillmentsRequestSchema,
  ReconcileFulfillmentsResponseSchema,
  ReconcileShipmentLegMetrcRefsRequestSchema,
  ReconcileShipmentLegMetrcRefsResponseSchema,
  ReconcileShipmentLegMetrcRefsScopeSchema,
  RemoveHubSplitRequestSchema,
  RemoveHubSplitResponseSchema,
  ReorderStopsRequestSchema,
  ReorderStopsResponseSchema,
  RouteBoundsSchema,
  RouteOptimizationModeSchema,
  RouteOptimizationParamsSchema,
  RoutePlanSchema,
  RoutePlanSummarySchema,
  RoutePointSchema,
  ShipmentDetailResponseSchema,
  ShipmentLegManifestActionResponseSchema,
  ShipmentLegQueueListResponseSchema,
  ShipmentManifestActionResponseSchema,
  ShipmentQueueSummariesResponseSchema,
  SubmitShipmentLegManifestRequestSchema,
  SubmitShipmentManifestRequestSchema,
  SupplierDeliveryTeamSchema,
  SupplierLocationTeamSchema,
  SupplierLocationTeamWithDetailsSchema,
  SyncDeliveryProofAssetRequestSchema,
  SyncDeliveryProofAssetResponseSchema,
  SyncResponseSchema,
  SyncTeamResultSchema,
  TaskAddressSchema,
  TaskAssignmentResultSchema,
  TaskRouteSchema,
  TeamAutoDispatchRequestSchema,
  TeamAutoDispatchResponseSchema,
  TeamMembersSchema,
  TeamSchema,
  TimelineEntrySchema,
  UpdateDriverRequestSchema,
  UpdateDriverTeamsInputSchema,
  UpdateHubMetadataRequestSchema,
  UpdateHubMetadataResponseSchema,
  UpdateHubRequestSchema,
  UpdatePartitionRequestSchema,
  UpdatePriorityRequestSchema,
  UpdateRecipientRequestSchema,
  UpdateRoutePlanTasksInputSchema,
  UpdateShipmentLegManifestRequestSchema,
  UpdateShipmentLegRequestSchema,
  UpdateShipmentLegResponseSchema,
  UpdateSupplierDeliveryTeamRequestSchema,
  UpdateSupplierDriverInputSchema,
  UpdateSupplierVehicleInputSchema,
  UpdateTaskRequestSchema,
  UpdateTeamRequestSchema,
  UpdateVehicleRequestSchema,
  VehicleSchema,
  VehicleStatusSchema,
  VehicleTypeSchema,
  VoidShipmentLegManifestRequestSchema,
  adminAuthContract,
  adminDashboardContract,
  adminDestinationsContract,
  adminDriversContract,
  adminHubsContract,
  adminOnfleetWebhooksContract,
  adminOrdersContract,
  adminPartitionsContract,
  adminRecipientsContract,
  adminRouteOptimizationContract,
  adminRoutesContract,
  adminTasksContract,
  adminTeamsContract,
  adminVehiclesContract,
  assignmentQueueContract,
  auxiliaryTasksContract,
  deliveryGatewayContract,
  internalAssignmentQueueContract,
  internalDatabaseFailoverContract,
  internalPartitionTasksContract,
  jobsContract,
  shipmentLegsContract,
  supplierDeliveryTeamContract,
  supplierDriversContract,
  supplierRoutePlansContract,
  supplierRoutesContract,
  supplierVehiclesContract,
  trackingContract,
  webhooksContract
} from "../chunk-JZOTMDAP.js";

// src/http/index.ts
import { initContract as initContract36 } from "@ts-rest/core";

// src/http/analytics.contract.ts
import { initContract } from "@ts-rest/core";
import { z } from "zod";
var c = initContract();
var AnalyticsCaptureEventSchema = z.object({
  event: z.string().min(1),
  distinct_id: z.string().min(1),
  properties: z.record(z.unknown()).optional(),
  timestamp: z.string().optional(),
  $groups: z.record(z.string()).optional()
});
var AnalyticsBatchEventSchema = z.object({
  event: z.string().min(1),
  properties: z.object({
    distinct_id: z.string().min(1)
  }).and(z.record(z.unknown())),
  timestamp: z.string().optional()
});
var AnalyticsBatchRequestSchema = z.object({
  batch: z.array(AnalyticsBatchEventSchema).min(1).max(100),
  historical_migration: z.boolean().optional()
});
var AnalyticsIdentifySchema = z.object({
  distinct_id: z.string().min(1),
  $set: z.record(z.unknown()).optional(),
  $set_once: z.record(z.unknown()).optional()
});
var AnalyticsGroupIdentifySchema = z.object({
  distinct_id: z.string().min(1),
  group_type: z.string().min(1),
  group_key: z.string().min(1),
  properties: z.record(z.unknown()).optional()
});
var AnalyticsSuccessResponseSchema = z.object({
  status: z.literal(1).or(z.literal("ok")).optional()
});
var AnalyticsErrorResponseSchema = z.object({
  message: z.string()
});
var analyticsContract = c.router({
  /**
   * Capture a single analytics event
   * Proxies to PostHog /i/v0/e/
   */
  capture: {
    method: "POST",
    path: "/api/analytics/capture",
    body: AnalyticsCaptureEventSchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Capture a single analytics event"
  },
  /**
   * Capture multiple analytics events in a batch
   * Proxies to PostHog /batch/
   */
  batch: {
    method: "POST",
    path: "/api/analytics/batch",
    body: AnalyticsBatchRequestSchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Capture multiple analytics events in a batch"
  },
  /**
   * Identify a user with properties
   * Proxies to PostHog as $identify event
   */
  identify: {
    method: "POST",
    path: "/api/analytics/identify",
    body: AnalyticsIdentifySchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Identify a user with properties"
  },
  /**
   * Identify a group (company, brand, etc.)
   * Proxies to PostHog as $groupidentify event
   */
  groupIdentify: {
    method: "POST",
    path: "/api/analytics/group",
    body: AnalyticsGroupIdentifySchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Identify a group with properties"
  }
});

// src/http/brands.contract.ts
import { initContract as initContract2 } from "@ts-rest/core";
import { z as z2 } from "zod";
import { BrandDtoSchema } from "@flote/types/brand";
var c2 = initContract2();
var brandsContract = c2.router({
  list: {
    method: "GET",
    path: "/api/brands",
    responses: {
      200: z2.array(BrandDtoSchema),
      401: z2.object({ message: z2.string() }),
      500: z2.object({ message: z2.string() })
    },
    summary: "List all brands"
  },
  getById: {
    method: "GET",
    path: "/api/brands/:id",
    pathParams: z2.object({ id: z2.string() }),
    responses: {
      200: BrandDtoSchema,
      400: z2.object({ message: z2.string() }),
      401: z2.object({ message: z2.string() }),
      404: z2.object({ message: z2.string() }),
      500: z2.object({ message: z2.string() })
    },
    summary: "Get brand by ID"
  },
  create: {
    method: "POST",
    path: "/api/brands",
    body: z2.object({
      name: z2.string(),
      logoUrl: z2.string().nullable().optional(),
      description: z2.string().nullable().optional(),
      b2bwaveBrandId: z2.number().nullable().optional()
    }),
    responses: {
      201: BrandDtoSchema,
      400: z2.object({ message: z2.string() }),
      401: z2.object({ message: z2.string() }),
      403: z2.object({ message: z2.string() }),
      409: z2.object({ message: z2.string() }),
      422: z2.object({ message: z2.string() }),
      500: z2.object({ message: z2.string() })
    },
    summary: "Create a new brand"
  },
  update: {
    method: "PUT",
    path: "/api/brands/:id",
    pathParams: z2.object({ id: z2.string() }),
    body: z2.object({
      name: z2.string().optional(),
      logoUrl: z2.string().nullable().optional(),
      description: z2.string().nullable().optional(),
      b2bwaveBrandId: z2.number().nullable().optional()
    }),
    responses: {
      200: BrandDtoSchema,
      400: z2.object({ message: z2.string() }),
      401: z2.object({ message: z2.string() }),
      403: z2.object({ message: z2.string() }),
      404: z2.object({ message: z2.string() }),
      409: z2.object({ message: z2.string() }),
      422: z2.object({ message: z2.string() }),
      500: z2.object({ message: z2.string() }),
      501: z2.object({ message: z2.string() })
    },
    summary: "Update an existing brand"
  },
  delete: {
    method: "DELETE",
    path: "/api/brands/:id",
    pathParams: z2.object({ id: z2.string() }),
    responses: {
      204: z2.void(),
      401: z2.object({ message: z2.string() }),
      403: z2.object({ message: z2.string() }),
      404: z2.object({ message: z2.string() }),
      409: z2.object({ message: z2.string() }),
      500: z2.object({ message: z2.string() }),
      501: z2.object({ message: z2.string() })
    },
    summary: "Delete a brand by ID"
  }
});

// src/http/b2bwave-brands.contract.ts
import { initContract as initContract3 } from "@ts-rest/core";
import { z as z3 } from "zod";
import { B2BWaveBrandDtoSchema } from "@flote/types/brand";
var c3 = initContract3();
var b2bwaveBrandsContract = c3.router({
  list: {
    method: "GET",
    path: "/api/providers/b2bwave/brands",
    responses: {
      200: z3.array(B2BWaveBrandDtoSchema),
      401: z3.object({ message: z3.string() }),
      500: z3.object({ message: z3.string() })
    },
    summary: "List all brands from B2BWave"
  },
  getById: {
    method: "GET",
    path: "/api/providers/b2bwave/brands/:id",
    pathParams: z3.object({ id: z3.string() }),
    responses: {
      200: B2BWaveBrandDtoSchema,
      400: z3.object({ message: z3.string() }),
      401: z3.object({ message: z3.string() }),
      404: z3.object({ message: z3.string() }),
      500: z3.object({ message: z3.string() })
    },
    summary: "Get B2BWave brand by ID"
  }
});

// src/http/auth.contract.ts
import { initContract as initContract4 } from "@ts-rest/core";
import { z as z4 } from "zod";
import { PaymentMethod } from "@flote/types/customer-capabilities";
var c4 = initContract4();
var PaymentMethodSchema = z4.nativeEnum(PaymentMethod);
var AuthCustomerSchema = z4.object({
  id: z4.number(),
  email: z4.string().email(),
  companyName: z4.string(),
  companyNumber: z4.string().nullable().optional(),
  role: z4.string(),
  name: z4.string().nullable().optional(),
  phone: z4.string().nullable().optional(),
  address: z4.string().nullable().optional(),
  city: z4.string().nullable().optional(),
  paymentWays: z4.array(z4.string()).default([]),
  companyActivities: z4.string().nullable().optional(),
  canConfirmOrder: z4.boolean().nullable().optional(),
  disableOrdering: z4.boolean().nullable().optional(),
  hasPortalAccess: z4.boolean().optional(),
  // Customer capabilities - allowed payment methods for checkout
  allowedPaymentMethods: z4.array(PaymentMethodSchema).optional()
});
var SuccessResponse = z4.object({ success: z4.boolean() });
var authContract = c4.router({
  me: {
    method: "GET",
    path: "/api/auth/me",
    responses: {
      200: AuthCustomerSchema,
      401: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Get authenticated customer context"
  },
  verifyEmail: {
    method: "POST",
    path: "/api/auth/verify-email",
    body: z4.object({ email: z4.string().email() }),
    responses: {
      200: z4.object({
        success: z4.boolean(),
        message: z4.string().optional(),
        companyName: z4.string().optional()
      }),
      400: z4.object({ message: z4.string() }),
      404: z4.object({ message: z4.string() }),
      429: z4.object({ message: z4.string(), retryAfter: z4.number().optional() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Start email verification and send OTP"
  },
  verifyOtp: {
    method: "POST",
    path: "/api/auth/verify-otp",
    body: z4.object({ email: z4.string().email(), otp: z4.string().min(1) }),
    responses: {
      200: z4.object({
        success: z4.boolean(),
        message: z4.string().optional(),
        jwt: z4.string().optional(),
        refreshToken: z4.string().optional(),
        customer: AuthCustomerSchema.nullable().optional()
      }),
      400: z4.object({ message: z4.string() }),
      401: z4.object({ message: z4.string() }),
      429: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() }),
      503: z4.object({ message: z4.string() })
    },
    summary: "Validate OTP and issue session"
  },
  sendSmsOtp: {
    method: "POST",
    path: "/api/auth/send-sms-otp",
    body: z4.object({
      phoneNumber: z4.string().min(1, "Phone number is required"),
      email: z4.string().email()
    }),
    responses: {
      200: z4.object({
        success: z4.boolean(),
        message: z4.string().optional(),
        verificationId: z4.string().optional()
      }),
      400: z4.object({ message: z4.string() }),
      404: z4.object({ message: z4.string() }),
      429: z4.object({ message: z4.string(), retryAfter: z4.number().optional() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Start SMS verification and send OTP to phone number"
  },
  verifySmsOtp: {
    method: "POST",
    path: "/api/auth/verify-sms-otp",
    body: z4.object({
      phoneNumber: z4.string().min(1, "Phone number is required"),
      otp: z4.string().min(1, "OTP code is required"),
      email: z4.string().email()
    }),
    responses: {
      200: z4.object({
        success: z4.boolean(),
        message: z4.string().optional(),
        jwt: z4.string().optional(),
        refreshToken: z4.string().optional(),
        customer: AuthCustomerSchema.nullable().optional()
      }),
      400: z4.object({ message: z4.string() }),
      401: z4.object({ message: z4.string() }),
      429: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() }),
      503: z4.object({ message: z4.string() })
    },
    summary: "Validate SMS OTP and issue session"
  },
  refresh: {
    method: "POST",
    path: "/api/auth/refresh",
    body: z4.object({
      refreshToken: z4.string().optional()
    }),
    responses: {
      200: z4.object({
        success: z4.boolean(),
        message: z4.string().optional(),
        jwt: z4.string().optional(),
        refreshToken: z4.string().optional(),
        customer: AuthCustomerSchema.nullable().optional()
      }),
      401: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Refresh auth token using refresh token or valid access token"
  },
  updateProfile: {
    method: "PATCH",
    path: "/api/auth/me/profile",
    body: z4.object({
      firstName: z4.string().min(1).max(100),
      lastName: z4.string().min(1).max(100)
    }),
    responses: {
      200: z4.object({ success: z4.boolean(), name: z4.string() }),
      401: z4.object({ message: z4.string() }),
      404: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Update authenticated user profile name"
  },
  logout: {
    method: "POST",
    path: "/api/auth/logout",
    body: z4.object({}),
    responses: {
      200: SuccessResponse.extend({ message: z4.string().optional() }),
      401: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Clear auth session"
  }
});

// src/http/portal-auth.contract.ts
import { initContract as initContract5 } from "@ts-rest/core";
import { z as z5 } from "zod";
var c5 = initContract5();
var PortalUserRoleSchema = z5.enum([
  "flote_admin",
  "sales_rep",
  "supplier_admin",
  "supplier_member",
  "supplier"
  // @deprecated
]);
var PortalBrandSchema = z5.object({
  id: z5.string(),
  name: z5.string(),
  logoUrl: z5.string().nullable(),
  description: z5.string().nullable(),
  b2bwaveBrandId: z5.number().nullable()
});
var AccessibleEmbedSchema = z5.object({
  id: z5.number(),
  hostDomain: z5.string(),
  brand: PortalBrandSchema.nullable()
});
var PortalUserSchema = z5.object({
  id: z5.string().uuid(),
  email: z5.string().email(),
  name: z5.string(),
  role: PortalUserRoleSchema,
  supplierId: z5.string().uuid().nullable(),
  memberId: z5.string().uuid().nullable(),
  organizationId: z5.string().uuid().nullable(),
  /** @deprecated Use hasAnyLocalDeliveryBrand + brandFulfillmentMethods instead */
  organizationFulfillmentMethod: z5.enum(["local_delivery", "mail_carrier"]).nullable(),
  hasAnyLocalDeliveryBrand: z5.boolean().nullable().default(null),
  brandFulfillmentMethods: z5.record(z5.string(), z5.enum(["local_delivery", "mail_carrier"])).nullable().default(null),
  b2bwaveSalesRepId: z5.number().nullable(),
  isActive: z5.boolean(),
  createdAt: z5.coerce.date(),
  updatedAt: z5.coerce.date()
});
var SuccessResponse2 = z5.object({ success: z5.boolean() });
var portalAuthContract = c5.router({
  me: {
    method: "GET",
    path: "/api/portal-auth/me",
    responses: {
      200: PortalUserSchema,
      401: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Get authenticated portal user context"
  },
  verifyEmail: {
    method: "POST",
    path: "/api/portal-auth/verify-email",
    body: z5.object({ email: z5.string().email() }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        name: z5.string().optional(),
        role: PortalUserRoleSchema.optional()
      }),
      400: z5.object({ message: z5.string() }),
      403: z5.object({ message: z5.string() }),
      404: z5.object({ message: z5.string() }),
      429: z5.object({ message: z5.string(), retryAfter: z5.number().optional() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Verify email is a portal user and send OTP"
  },
  verifyOtp: {
    method: "POST",
    path: "/api/portal-auth/verify-otp",
    body: z5.object({
      email: z5.string().email(),
      otp: z5.string().min(1)
    }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        jwt: z5.string().optional(),
        refreshToken: z5.string().optional(),
        portalUser: PortalUserSchema.nullable().optional()
      }),
      400: z5.object({ message: z5.string() }),
      401: z5.object({ message: z5.string() }),
      403: z5.object({ message: z5.string() }),
      429: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Validate OTP and issue portal session"
  },
  refresh: {
    method: "POST",
    path: "/api/portal-auth/refresh",
    body: z5.object({
      refreshToken: z5.string().optional()
    }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        jwt: z5.string().optional(),
        refreshToken: z5.string().optional(),
        portalUser: PortalUserSchema.nullable().optional()
      }),
      401: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Refresh portal auth token"
  },
  logout: {
    method: "POST",
    path: "/api/portal-auth/logout",
    body: z5.object({}),
    responses: {
      200: SuccessResponse2.extend({ message: z5.string().optional() }),
      401: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Clear portal auth session"
  },
  accessibleEmbeds: {
    method: "GET",
    path: "/api/portal-auth/accessible-embeds",
    responses: {
      200: z5.array(AccessibleEmbedSchema),
      401: z5.object({ message: z5.string() }),
      403: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Get embed configs accessible by the authenticated portal user"
  }
});

// src/http/products.contract.ts
import { initContract as initContract6 } from "@ts-rest/core";
import { z as z6 } from "zod";
var c6 = initContract6();
var B2BWaveProductCustomerPriceDtoSchema = z6.object({
  id: z6.number(),
  productId: z6.number(),
  customerId: z6.number(),
  applyExtraDiscounts: z6.boolean(),
  price: z6.string(),
  createdAt: z6.string(),
  updatedAt: z6.string()
});
var B2BWaveProductPriceDtoSchema = z6.object({
  id: z6.number(),
  productId: z6.number(),
  pricelistId: z6.number(),
  price: z6.string(),
  createdAt: z6.string(),
  updatedAt: z6.string()
});
var B2BWaveProductFileDtoSchema = z6.object({
  id: z6.number(),
  productId: z6.number(),
  filename: z6.string(),
  title: z6.string(),
  url: z6.string(),
  createdAt: z6.string(),
  updatedAt: z6.string()
});
var B2BWaveProductVariantOptionSchema = z6.object({
  option: z6.string(),
  value: z6.string()
});
var B2BWaveProductVariantSchema = z6.object({
  code: z6.string(),
  optionValues: z6.array(B2BWaveProductVariantOptionSchema)
});
var B2BWaveWarehouseQuantitySchema = z6.object({
  warehouseId: z6.number(),
  warehouseCode: z6.string(),
  quantity: z6.string()
});
var B2BWaveProductDtoSchema = z6.object({
  id: z6.number(),
  name: z6.string(),
  brandId: z6.number().nullable(),
  description: z6.string(),
  partNumber: z6.string(),
  isActive: z6.boolean(),
  statusId: z6.number().nullable(),
  categoryId: z6.number(),
  canBackorder: z6.boolean().nullable(),
  quantity: z6.number().nullable().optional(),
  // Deprecated: Use quantities array instead
  promoteCategory: z6.boolean(),
  promoteFront: z6.boolean(),
  price1: z6.number().nullable(),
  price2: z6.number().nullable(),
  price3: z6.number().nullable(),
  createdAt: z6.string(),
  updatedAt: z6.string(),
  imageFileName: z6.string().nullable(),
  imageContentType: z6.string().nullable(),
  imageFileSize: z6.number().nullable(),
  imageUpdatedAt: z6.string().nullable(),
  oldId: z6.number().nullable(),
  minimumQuantity: z6.string(),
  vatClassId: z6.number(),
  metaDescription: z6.string().nullable(),
  measurementUnitId: z6.number().nullable(),
  packageQuantity: z6.number().nullable(),
  hasVariants: z6.boolean(),
  codeUpc: z6.string(),
  importImageUrl: z6.string().nullable(),
  importImageUrlUpdatedAt: z6.string().nullable(),
  importUuid: z6.string().nullable(),
  manufacturerId: z6.number().nullable(),
  priceMsrp: z6.number().nullable(),
  tagLine: z6.string().nullable(),
  code: z6.string(),
  imageUrl: z6.string(),
  galleryImageUrls: z6.array(z6.string()),
  categoryPath: z6.string(),
  productVariants: z6.array(B2BWaveProductVariantSchema),
  quantities: z6.array(B2BWaveWarehouseQuantitySchema).optional(),
  customerPrice: B2BWaveProductCustomerPriceDtoSchema.optional()
});
var EnrichedB2BWaveProductSchema = B2BWaveProductDtoSchema.extend({
  pricing: B2BWaveProductPriceDtoSchema.optional()
});
var GetB2BWaveProductsInputDtoSchema = z6.object({
  codeEq: z6.string().optional(),
  idEq: z6.coerce.number().optional(),
  nameEq: z6.string().optional(),
  statusIdEq: z6.coerce.number().optional(),
  categoryIdEq: z6.coerce.number().optional(),
  brandIdEq: z6.coerce.number().optional(),
  isActiveEq: z6.preprocess(
    (val) => val === "true" || val === true,
    z6.boolean()
  ).optional(),
  codeCont: z6.string().optional(),
  nameCont: z6.string().optional(),
  descriptionCont: z6.string().optional(),
  // The provider expects paginated=1; coerce string "1" to number, then validate literal
  paginated: z6.coerce.number().pipe(z6.literal(1)).optional(),
  perPage: z6.coerce.number().optional(),
  page: z6.coerce.number().optional()
});
var GetB2BWaveProductCustomerPricesInputDtoSchema = z6.object({
  productIdEq: z6.coerce.number().optional(),
  customerIdEq: z6.coerce.number().optional()
});
var CreateProductBody = z6.object({
  name: z6.string(),
  imageUrl: z6.string(),
  categoryId: z6.string().nullable(),
  brandId: z6.string(),
  price: z6.number(),
  description: z6.string(),
  thcContent: z6.string().nullable(),
  weight: z6.string().nullable(),
  packageQuantity: z6.number(),
  inventory: z6.number(),
  featured: z6.boolean(),
  backordered: z6.boolean(),
  type: z6.string()
});
var productsContract = c6.router({
  // B2BWave backed product endpoints
  b2bwaveList: {
    method: "GET",
    path: "/api/b2bwave/products",
    query: GetB2BWaveProductsInputDtoSchema.optional(),
    responses: {
      200: z6.array(B2BWaveProductDtoSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "List B2BWave products"
  },
  b2bwaveListWithPricing: {
    method: "GET",
    path: "/api/b2bwave/products-with-pricing",
    query: GetB2BWaveProductsInputDtoSchema.optional(),
    responses: {
      200: z6.array(EnrichedB2BWaveProductSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "List all B2BWave products with pricing (includes customer pricing when authenticated)"
  },
  b2bwaveByBrand: {
    method: "GET",
    path: "/api/b2bwave/brands/:brandId/products",
    pathParams: z6.object({ brandId: z6.string() }),
    responses: {
      200: z6.array(B2BWaveProductDtoSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      404: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "List B2BWave products by brand ID"
  },
  b2bwaveByBrandWithPricing: {
    method: "GET",
    path: "/api/b2bwave/brands/:brandId/products-with-pricing",
    pathParams: z6.object({ brandId: z6.string() }),
    responses: {
      200: z6.array(EnrichedB2BWaveProductSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      404: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "List B2BWave products by brand ID, including pricing/customer pricing where applicable"
  },
  b2bwaveCustomerPricingForProducts: {
    method: "GET",
    path: "/api/b2bwave/customer-pricing/products",
    query: z6.object({
      productIds: z6.array(z6.coerce.number()),
      customerId: z6.coerce.number()
    }),
    responses: {
      200: z6.array(B2BWaveProductCustomerPriceDtoSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      404: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "Get customer pricing for multiple products"
  },
  b2bwaveCustomerPricingByCustomerId: {
    method: "GET",
    path: "/api/b2bwave/customer-pricing/customer/:customerId",
    pathParams: z6.object({ customerId: z6.coerce.number() }),
    responses: {
      200: z6.array(B2BWaveProductCustomerPriceDtoSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      404: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "Get all customer pricing entries for a customer"
  },
  b2bwaveCustomerPricingForProduct: {
    method: "GET",
    path: "/api/b2bwave/customer-pricing/product",
    query: GetB2BWaveProductCustomerPricesInputDtoSchema,
    responses: {
      200: B2BWaveProductCustomerPriceDtoSchema.nullable(),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "Get customer pricing for a specific product/customer pair"
  },
  b2bwaveInvalidateProductsCache: {
    method: "POST",
    body: z6.object({}),
    path: "/api/b2bwave/products/cache/invalidate",
    responses: {
      200: z6.object({ success: z6.boolean() }),
      401: z6.object({ message: z6.string() }),
      403: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Invalidate B2BWave products cache"
  },
  b2bwaveListPaginated: {
    method: "GET",
    path: "/api/b2bwave/products-paginated",
    query: z6.object({
      limit: z6.coerce.number().min(1).max(100).default(24),
      cursor: z6.string().optional(),
      brandIdEq: z6.coerce.number().optional(),
      categoryIdEq: z6.coerce.number().optional(),
      nameCont: z6.string().optional()
    }),
    responses: {
      200: z6.object({
        products: z6.array(EnrichedB2BWaveProductSchema),
        nextCursor: z6.string().nullable(),
        hasMore: z6.boolean()
      }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "List B2BWave products with cursor-based pagination (filters samples and inactive brands)"
  },
  b2bwaveListByIds: {
    method: "GET",
    path: "/api/b2bwave/products-by-ids",
    query: z6.object({
      ids: z6.string().transform((val) => val.split(",").map(Number))
    }),
    responses: {
      200: z6.array(EnrichedB2BWaveProductSchema),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "Get B2BWave products by IDs (for cart sync)"
  },
  b2bwaveBulkUpsertCustomerPricing: {
    method: "POST",
    path: "/api/b2bwave/customer-pricing/bulk-upsert",
    body: z6.object({
      productIds: z6.array(z6.number()),
      customerIds: z6.array(z6.number()),
      price: z6.number()
    }),
    responses: {
      200: z6.object({
        created: z6.number(),
        updated: z6.number(),
        failed: z6.number(),
        errors: z6.array(z6.object({
          productId: z6.number(),
          customerId: z6.number(),
          error: z6.string()
        }))
      }),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "Bulk create or update customer pricing for multiple product/customer combinations"
  },
  b2bwaveProductFiles: {
    method: "GET",
    path: "/api/b2bwave/products/:productId/files",
    pathParams: z6.object({ productId: z6.coerce.number() }),
    responses: {
      200: z6.array(B2BWaveProductFileDtoSchema),
      400: z6.object({ message: z6.string() }),
      404: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() }),
      502: z6.object({ message: z6.string() })
    },
    summary: "Get files/documents associated with a product (COAs, labels, etc.)"
  }
});

// src/http/product-sync.contract.ts
import { initContract as initContract7 } from "@ts-rest/core";
import { z as z7 } from "zod";
var c7 = initContract7();
var SyncErrorSchema = z7.object({
  entityType: z7.string(),
  externalId: z7.string(),
  message: z7.string()
});
var DryRunActionSchema = z7.object({
  type: z7.enum(["create", "update", "skip", "delete"]),
  entityType: z7.enum([
    "product",
    "brand",
    "category",
    "variant",
    "image",
    "file",
    "stock_location",
    "brand_stock_location",
    "inventory_adjustment",
    "price"
  ]),
  externalId: z7.string(),
  name: z7.string().optional(),
  reason: z7.string().optional(),
  details: z7.record(z7.unknown()).optional()
});
var SyncResultSchema = z7.object({
  success: z7.boolean(),
  created: z7.number(),
  updated: z7.number(),
  skipped: z7.number(),
  failed: z7.number(),
  errors: z7.array(SyncErrorSchema),
  duration: z7.number(),
  dryRun: z7.boolean().optional(),
  dryRunActions: z7.array(DryRunActionSchema).optional()
});
var OrchestrateSyncResultSchema = z7.object({
  success: z7.boolean(),
  brands: SyncResultSchema,
  categories: SyncResultSchema,
  products: SyncResultSchema,
  inventoryLevels: SyncResultSchema.optional(),
  basePricing: SyncResultSchema.optional(),
  bulkDiscounts: SyncResultSchema.optional(),
  totalDuration: z7.number(),
  dryRun: z7.boolean()
});
var productSyncContract = c7.router({
  syncAll: {
    method: "POST",
    path: "/api/admin/product-sync",
    body: z7.object({}).optional(),
    responses: {
      200: SyncResultSchema,
      401: z7.object({ message: z7.string() }),
      403: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() })
    },
    summary: "Sync all products from B2BWave to local database"
  },
  syncOne: {
    method: "POST",
    path: "/api/admin/product-sync/:b2bwaveProductId",
    pathParams: z7.object({ b2bwaveProductId: z7.string() }),
    body: z7.object({}).optional(),
    responses: {
      200: SyncResultSchema,
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      403: z7.object({ message: z7.string() }),
      404: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() })
    },
    summary: "Sync a single product by B2BWave ID"
  },
  syncInventory: {
    method: "POST",
    path: "/api/admin/product-sync/inventory",
    body: z7.object({}).optional(),
    responses: {
      200: SyncResultSchema,
      401: z7.object({ message: z7.string() }),
      403: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() })
    },
    summary: "Sync inventory levels from B2BWave to local database"
  },
  orchestrate: {
    method: "POST",
    path: "/api/admin/product-sync/orchestrate",
    body: z7.object({
      dryRun: z7.boolean().optional().default(false)
    }),
    responses: {
      200: OrchestrateSyncResultSchema,
      401: z7.object({ message: z7.string() }),
      403: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() })
    },
    summary: "Orchestrate full catalog sync (brands, categories, products)"
  }
});

// src/http/categories.contract.ts
import { initContract as initContract8 } from "@ts-rest/core";
import { z as z8 } from "zod";
import { CategoryDtoSchema } from "@flote/types/category";
import { ProductRealmSchema } from "@flote/types/product";
var c8 = initContract8();
var CreateCategoryBody = z8.object({
  name: z8.string(),
  description: z8.string().nullable().optional(),
  parentId: z8.string().nullable().optional()
});
var B2BWaveCategoryDtoSchema = z8.object({
  id: z8.number(),
  name: z8.string(),
  description: z8.string().optional(),
  metaDescription: z8.string().optional(),
  parentId: z8.number().nullable().optional(),
  isActive: z8.boolean(),
  discount: z8.number().nullable().optional(),
  sort: z8.number().nullable().optional(),
  isPrivate: z8.boolean().optional(),
  subcategoriesPrivate: z8.boolean().optional(),
  categoryPath: z8.string().optional(),
  depth: z8.number().optional(),
  lft: z8.number().optional(),
  rgt: z8.number().optional(),
  createdAt: z8.string().optional(),
  updatedAt: z8.string().optional()
});
var GetB2BWaveCategoriesInputDtoSchema = z8.object({
  nameEq: z8.string().optional(),
  nameCont: z8.string().optional(),
  isActiveEq: z8.preprocess(
    (val) => val === "true" || val === true,
    z8.boolean()
  ).optional(),
  parentIdEq: z8.coerce.number().nullable().optional(),
  paginated: z8.coerce.number().pipe(z8.literal(1)).optional(),
  perPage: z8.coerce.number().optional(),
  page: z8.coerce.number().optional()
});
var categoriesContract = c8.router({
  // Internal DB-backed endpoints
  list: {
    method: "GET",
    path: "/api/categories",
    query: z8.object({
      realm: ProductRealmSchema.optional()
    }).optional(),
    responses: {
      200: z8.array(CategoryDtoSchema)
    },
    summary: "List categories, optionally filtered by realm"
  },
  getById: {
    method: "GET",
    path: "/api/categories/:id",
    pathParams: z8.object({ id: z8.string() }),
    responses: {
      200: CategoryDtoSchema,
      404: z8.object({ message: z8.string() })
    },
    summary: "Get category by ID"
  },
  create: {
    method: "POST",
    path: "/api/categories",
    body: CreateCategoryBody,
    responses: {
      201: CategoryDtoSchema,
      400: z8.object({ message: z8.string() })
    },
    summary: "Create a new category"
  },
  // B2BWave-backed category endpoints
  b2bwaveList: {
    method: "GET",
    path: "/api/b2bwave/categories",
    query: GetB2BWaveCategoriesInputDtoSchema.optional(),
    responses: {
      200: z8.array(B2BWaveCategoryDtoSchema),
      400: z8.object({ message: z8.string() }),
      500: z8.object({ message: z8.string() }),
      502: z8.object({ message: z8.string() })
    },
    summary: "List B2BWave categories"
  },
  b2bwaveGetById: {
    method: "GET",
    path: "/api/b2bwave/categories/:id",
    pathParams: z8.object({ id: z8.string() }),
    responses: {
      200: B2BWaveCategoryDtoSchema,
      400: z8.object({ message: z8.string() }),
      404: z8.object({ message: z8.string() }),
      500: z8.object({ message: z8.string() }),
      502: z8.object({ message: z8.string() })
    },
    summary: "Get B2BWave category by ID"
  }
});

// src/http/customers.contract.ts
import { initContract as initContract9 } from "@ts-rest/core";
import { z as z9 } from "zod";
import { B2BWaveCustomerDtoSchema, CreateCustomerDtoSchema } from "@flote/types/customer";
var c9 = initContract9();
var GetB2BWaveCustomersInputDtoSchema = z9.object({
  idEq: z9.coerce.number().optional(),
  emailEq: z9.string().email().optional(),
  companyNameEq: z9.string().optional(),
  nameEq: z9.string().optional(),
  pricelistIdEq: z9.number().optional(),
  emailCont: z9.string().optional(),
  companyNameCont: z9.string().optional(),
  nameCont: z9.string().optional()
});
var customersContract = c9.router({
  list: {
    method: "GET",
    path: "/api/b2bwave/customers",
    query: GetB2BWaveCustomersInputDtoSchema.optional(),
    responses: {
      200: z9.array(B2BWaveCustomerDtoSchema),
      400: z9.object({ message: z9.string() }),
      401: z9.object({ message: z9.string() }),
      500: z9.object({ message: z9.string() })
    },
    summary: "List B2BWave customers"
  },
  getByEmail: {
    method: "GET",
    path: "/api/b2bwave/customers/by-email",
    query: z9.object({ email: z9.string().email() }),
    responses: {
      200: B2BWaveCustomerDtoSchema,
      400: z9.object({ message: z9.string() }),
      401: z9.object({ message: z9.string() }),
      404: z9.object({ message: z9.string() }),
      500: z9.object({ message: z9.string() })
    },
    summary: "Get B2BWave customer by email"
  },
  create: {
    method: "POST",
    path: "/api/b2bwave/customers",
    body: CreateCustomerDtoSchema,
    responses: {
      201: B2BWaveCustomerDtoSchema,
      400: z9.object({ message: z9.string() }),
      401: z9.object({ message: z9.string() }),
      409: z9.object({ message: z9.string() }),
      422: z9.object({ message: z9.string() }),
      500: z9.object({ message: z9.string() })
    },
    summary: "Create B2BWave customer"
  },
  getByIds: {
    method: "GET",
    path: "/api/b2bwave/customers/by-ids",
    query: z9.object({ ids: z9.string() }),
    // Comma-separated list of IDs
    responses: {
      200: z9.array(B2BWaveCustomerDtoSchema),
      400: z9.object({ message: z9.string() }),
      401: z9.object({ message: z9.string() }),
      500: z9.object({ message: z9.string() })
    },
    summary: "Get B2BWave customers by IDs"
  }
});

// src/http/addresses.contract.ts
import { initContract as initContract10 } from "@ts-rest/core";
import { z as z10 } from "zod";
import { B2BWaveAddressDtoSchema, CreateB2BWaveAddressDtoSchema } from "@flote/types/address";
var c10 = initContract10();
var addressesContract = c10.router({
  listByCustomerId: {
    method: "GET",
    path: "/api/b2bwave/customers/:customerId/addresses",
    pathParams: z10.object({ customerId: z10.coerce.number() }),
    responses: {
      200: z10.array(B2BWaveAddressDtoSchema),
      400: z10.object({ message: z10.string() }),
      401: z10.object({ message: z10.string() }),
      404: z10.object({ message: z10.string() }),
      500: z10.object({ message: z10.string() })
    },
    summary: "List B2BWave addresses by customer ID"
  },
  create: {
    method: "POST",
    path: "/api/b2bwave/addresses",
    body: CreateB2BWaveAddressDtoSchema,
    responses: {
      201: B2BWaveAddressDtoSchema,
      400: z10.object({ message: z10.string() }),
      401: z10.object({ message: z10.string() }),
      409: z10.object({ message: z10.string() }),
      422: z10.object({ message: z10.string() }),
      500: z10.object({ message: z10.string() })
    },
    summary: "Create B2BWave address"
  }
});

// src/http/orders.contract.ts
import { initContract as initContract11 } from "@ts-rest/core";
import { z as z11 } from "zod";
import {
  B2BWaveOrderWithProductsDtoSchema,
  B2BWaveOrderResponseDtoSchema,
  CreateB2BWaveOrderDtoSchema,
  GetB2BWaveOrdersQueryDtoSchema,
  GetB2BWaveOrderDocumentsDTOResponseSchema
} from "@flote/types/orders";
var c11 = initContract11();
var ordersContract = c11.router({
  list: {
    method: "GET",
    path: "/api/b2bwave/orders",
    query: GetB2BWaveOrdersQueryDtoSchema.optional(),
    responses: {
      200: z11.array(B2BWaveOrderWithProductsDtoSchema),
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() })
    },
    summary: "List B2BWave orders with their line items"
  },
  getById: {
    method: "GET",
    path: "/api/b2bwave/orders/:id",
    pathParams: z11.object({ id: z11.coerce.number() }),
    responses: {
      200: B2BWaveOrderWithProductsDtoSchema,
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      403: z11.object({ message: z11.string() }),
      404: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() })
    },
    summary: "Get B2BWave order by ID with line items"
  },
  getDocuments: {
    method: "GET",
    path: "/api/b2bwave/orders/:id/documents",
    pathParams: z11.object({ id: z11.coerce.number() }),
    responses: {
      200: GetB2BWaveOrderDocumentsDTOResponseSchema,
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      403: z11.object({ message: z11.string() }),
      404: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() })
    },
    summary: "Get B2BWave order documents by order ID"
  },
  create: {
    method: "POST",
    path: "/api/b2bwave/orders",
    body: CreateB2BWaveOrderDtoSchema,
    responses: {
      201: B2BWaveOrderResponseDtoSchema,
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      409: z11.object({ message: z11.string() }),
      422: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() }),
      503: z11.object({ message: z11.string() })
    },
    summary: "Create B2BWave order"
  },
  updateStatus: {
    method: "PATCH",
    path: "/api/b2bwave/orders/:id/status",
    pathParams: z11.object({ id: z11.coerce.number() }),
    body: z11.object({
      statusOrderId: z11.number()
    }),
    responses: {
      200: B2BWaveOrderResponseDtoSchema,
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      404: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() }),
      503: z11.object({ message: z11.string() })
    },
    summary: "Update B2BWave order status"
  }
});

// src/http/embed-config.contract.ts
import { initContract as initContract12 } from "@ts-rest/core";
import { z as z12 } from "zod";
import { BrandDtoSchema as BrandDtoSchema2 } from "@flote/types/brand";
import { ProductRealmSchema as ProductRealmSchema2 } from "@flote/types/product";
var c12 = initContract12();
var EmbedBrandingSchema = z12.object({
  primaryColor: z12.string().optional(),
  secondaryColor: z12.string().optional(),
  primaryTextColor: z12.string().optional(),
  secondaryTextColor: z12.string().optional()
});
var EmbedConfigResponseSchema = z12.object({
  brand: BrandDtoSchema2,
  branding: EmbedBrandingSchema.optional(),
  settings: z12.record(z12.unknown()),
  realm: ProductRealmSchema2
});
var embedConfigContract = c12.router({
  getByDomain: {
    method: "GET",
    path: "/api/embed-config",
    query: z12.object({ domain: z12.string() }),
    responses: {
      200: EmbedConfigResponseSchema.nullable(),
      400: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() })
    },
    summary: "Get embed config by domain"
  },
  invalidateCache: {
    method: "POST",
    path: "/api/embed-config/cache/invalidate",
    body: z12.object({ domain: z12.string() }),
    responses: {
      200: z12.object({ success: z12.boolean() }),
      400: z12.object({ message: z12.string() }),
      401: z12.object({ message: z12.string() }),
      403: z12.object({ message: z12.string() }),
      404: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() })
    },
    summary: "Invalidate embed config cache for domain"
  }
});

// src/http/email.contract.ts
import { initContract as initContract13 } from "@ts-rest/core";
import { z as z13 } from "zod";
var c13 = initContract13();
var ResendCreateEmailResponseSchema = z13.object({
  data: z13.object({ id: z13.string() }).nullable(),
  error: z13.object({ message: z13.string(), name: z13.string() }).nullable()
});
var MemberSchema = z13.object({
  name: z13.string(),
  email: z13.string().email()
});
var FileAttachmentSchema = z13.object({
  filename: z13.string(),
  content: z13.string(),
  contentType: z13.string(),
  size: z13.number()
});
var CreditApplicationSchema = z13.object({
  members: z13.array(MemberSchema),
  einNumber: z13.string(),
  operatingAgreementFile: FileAttachmentSchema,
  articlesOfIncorporationFile: FileAttachmentSchema,
  additionalNotes: z13.string().optional()
});
var emailContract = c13.router({
  sendEmail: {
    method: "POST",
    path: "/api/email/send",
    body: z13.object({
      to: z13.string().email(),
      subject: z13.string(),
      body: z13.string(),
      from: z13.string().email().optional()
    }),
    responses: {
      200: ResendCreateEmailResponseSchema,
      400: z13.object({ message: z13.string() }),
      401: z13.object({ message: z13.string() }),
      422: z13.object({ message: z13.string() }),
      500: z13.object({ message: z13.string() }),
      503: z13.object({ message: z13.string() })
    },
    summary: "Send a general email"
  },
  sendCreditApplicationEmail: {
    method: "POST",
    path: "/api/email/send-credit-application",
    body: z13.object({
      to: z13.string().email().optional(),
      from: z13.string().email().optional(),
      subject: z13.string().optional(),
      body: z13.string().optional(),
      creditApplication: CreditApplicationSchema
    }),
    responses: {
      200: ResendCreateEmailResponseSchema,
      400: z13.object({ message: z13.string() }),
      401: z13.object({ message: z13.string() }),
      413: z13.object({ message: z13.string() }),
      422: z13.object({ message: z13.string() }),
      500: z13.object({ message: z13.string() }),
      503: z13.object({ message: z13.string() })
    },
    summary: "Send a credit application email with attachments"
  }
});

// src/http/signnow.contract.ts
import { initContract as initContract14 } from "@ts-rest/core";
import { z as z14 } from "zod";
var c14 = initContract14();
var SignNowThumbnailSchema = z14.object({
  small: z14.string(),
  medium: z14.string(),
  large: z14.string()
});
var SignNowTemplateSchema = z14.object({
  id: z14.string(),
  name: z14.string(),
  thumbnail: SignNowThumbnailSchema,
  roles: z14.array(z14.string())
});
var SignNowDocumentGroupTemplateSchema = z14.object({
  id: z14.string(),
  name: z14.string(),
  ownerEmail: z14.string(),
  templates: z14.array(SignNowTemplateSchema),
  isPrepared: z14.boolean(),
  lastUpdated: z14.string()
});
var SignNowDocumentGroupTemplatesResponseSchema = z14.object({
  documentGroupTemplates: z14.array(SignNowDocumentGroupTemplateSchema),
  documentGroupTemplateTotalCount: z14.number()
});
var SignNowEmbeddedInviteLinkSchema = z14.object({ link: z14.string() });
var SignNowSigningLinkSchema = z14.object({ url: z14.string(), urlNoSignup: z14.string() });
var signnowContract = c14.router({
  getTemplates: {
    method: "GET",
    path: "/api/signnow/templates",
    responses: {
      200: SignNowDocumentGroupTemplatesResponseSchema
    },
    summary: "Get SignNow document group templates overview"
  },
  createEmbeddedInviteLink: {
    method: "POST",
    path: "/api/signnow/embedded-invite-link",
    body: z14.object({ email: z14.string().email() }),
    responses: {
      200: SignNowEmbeddedInviteLinkSchema,
      400: z14.object({ message: z14.string() })
    },
    summary: "Create an embedded invite link for a signer"
  },
  createSigningLink: {
    method: "POST",
    path: "/api/signnow/signing-link",
    body: z14.object({ documentId: z14.string() }),
    responses: {
      200: SignNowSigningLinkSchema,
      400: z14.object({ message: z14.string() })
    },
    summary: "Create a signing link for a document"
  }
});

// src/http/telnyx.contract.ts
import { initContract as initContract15 } from "@ts-rest/core";
import { z as z15 } from "zod";
var c15 = initContract15();
var TelnyxErrorSchema = z15.object({
  success: z15.literal(false),
  error: z15.object({
    code: z15.string(),
    message: z15.string(),
    help: z15.string().optional()
  })
});
var SendVerificationRequestSchema = z15.object({
  phoneNumber: z15.string().min(1, "Phone number is required"),
  customCode: z15.string().optional(),
  timeoutSecs: z15.number().positive().optional()
});
var SendVerificationResponseSchema = z15.object({
  id: z15.string(),
  phoneNumber: z15.string(),
  method: z15.enum(["sms", "call"]),
  expiresAt: z15.string().datetime(),
  status: z15.string()
});
var VerifyCodeRequestSchema = z15.object({
  phoneNumber: z15.string().min(1, "Phone number is required"),
  code: z15.string().min(1, "Verification code is required"),
  status: z15.enum(["accepted", "rejected"]).optional()
});
var VerifyCodeResponseSchema = z15.object({
  phoneNumber: z15.string(),
  verified: z15.boolean(),
  responseCode: z15.enum(["accepted", "rejected", "expired"]),
  verifiedAt: z15.string().datetime().optional()
});
var telnyxContract = c15.router({
  /**
   * Send verification code
   *
   * Initiates OTP verification flow by sending a code to the specified phone number.
   */
  sendVerification: {
    method: "POST",
    path: "/api/telnyx/verify/send",
    body: SendVerificationRequestSchema,
    responses: {
      200: SendVerificationResponseSchema,
      400: TelnyxErrorSchema,
      500: TelnyxErrorSchema
    },
    summary: "Send OTP verification code to a phone number"
  },
  /**
   * Verify OTP code
   *
   * Verifies the OTP code entered by the user against the verification ID.
   */
  verifyCode: {
    method: "POST",
    path: "/api/telnyx/verify/:verificationId/verify",
    pathParams: z15.object({
      verificationId: z15.string().min(1, "Verification ID is required")
    }),
    body: VerifyCodeRequestSchema,
    responses: {
      200: VerifyCodeResponseSchema,
      400: TelnyxErrorSchema,
      404: TelnyxErrorSchema,
      500: TelnyxErrorSchema
    },
    summary: "Verify OTP code for a verification session"
  }
});

// src/http/transactions.contract.ts
import { initContract as initContract16 } from "@ts-rest/core";
import { z as z16 } from "zod";
import {
  CreateTransactionRequestSchema,
  FloteTransactionSchema,
  TransactionValidationResultSchema,
  RefundTransactionRequestSchema,
  TransactionStatus
} from "@flote/types/transaction";
import {
  TransactionVerificationResultSchema,
  VerificationResultStatus
} from "@flote/types/scheduled-transaction";
var c16 = initContract16();
var transactionsContract = c16.router({
  createTransaction: {
    method: "POST",
    path: "/api/transactions",
    body: CreateTransactionRequestSchema,
    responses: {
      201: FloteTransactionSchema,
      400: z16.object({ message: z16.string() }),
      401: z16.object({ message: z16.string() }),
      422: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Create transaction"
  },
  validateTransaction: {
    method: "POST",
    path: "/api/transactions/validate",
    body: CreateTransactionRequestSchema,
    responses: {
      200: TransactionValidationResultSchema,
      400: z16.object({ message: z16.string() }),
      401: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Validate transaction request"
  },
  getTransactionById: {
    method: "GET",
    path: "/api/transactions/:id",
    pathParams: z16.object({
      id: z16.string().uuid()
    }),
    responses: {
      200: FloteTransactionSchema,
      401: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Get transaction by ID"
  },
  getTransactionsByOrderId: {
    method: "GET",
    path: "/api/transactions/order/:orderId",
    pathParams: z16.object({
      orderId: z16.string().min(1)
    }),
    responses: {
      200: z16.array(FloteTransactionSchema),
      401: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Get transactions by order ID"
  },
  updateTransactionStatus: {
    method: "PATCH",
    path: "/api/transactions/:id/status",
    pathParams: z16.object({
      id: z16.string().uuid()
    }),
    body: z16.object({
      status: z16.nativeEnum(TransactionStatus),
      providerMetadata: z16.record(z16.unknown()).optional()
    }),
    responses: {
      204: z16.void(),
      400: z16.object({ message: z16.string() }),
      401: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Update transaction status"
  },
  cancelTransaction: {
    method: "POST",
    path: "/api/transactions/:id/cancel",
    pathParams: z16.object({
      id: z16.string().uuid()
    }),
    body: z16.object({
      reason: z16.string().optional()
    }),
    responses: {
      200: FloteTransactionSchema,
      400: z16.object({ message: z16.string() }),
      401: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Cancel transaction"
  },
  refundTransaction: {
    method: "POST",
    path: "/api/transactions/:id/refund",
    pathParams: z16.object({
      id: z16.string().uuid()
    }),
    body: RefundTransactionRequestSchema,
    responses: {
      200: FloteTransactionSchema,
      400: z16.object({ message: z16.string() }),
      401: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Refund transaction"
  },
  verifyAchTransaction: {
    method: "POST",
    path: "/api/transactions/verify-ach",
    body: z16.object({
      providerTransactionId: z16.string(),
      checkSerialNumber: z16.string().optional()
    }),
    responses: {
      200: TransactionVerificationResultSchema,
      400: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Verify ACH transaction status with payment provider"
  },
  notifyFundsDebited: {
    method: "POST",
    path: "/api/transactions/notify-funds-debited",
    body: z16.object({
      orderId: z16.string(),
      customerId: z16.string(),
      transactionId: z16.string(),
      amount: z16.number(),
      currency: z16.string().default("USD")
    }),
    responses: {
      200: z16.object({ success: z16.boolean(), eventId: z16.string().optional() }),
      400: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string() }),
      500: z16.object({ message: z16.string() })
    },
    summary: "Publish ACH funds debited event for notification"
  },
  /**
   * Job endpoint for ACH status checks.
   * Called by job-worker to verify ACH transaction status and trigger appropriate actions.
   * This endpoint orchestrates: verification → status update → event publishing
   */
  checkAchStatusJob: {
    method: "POST",
    path: "/api/jobs/transactions/check-ach-status",
    body: z16.object({
      transactionId: z16.string().uuid(),
      providerTransactionId: z16.string(),
      checkSerialNumber: z16.string(),
      orderId: z16.string(),
      customerId: z16.number().positive(),
      previousStatus: z16.string().optional()
    }),
    responses: {
      200: z16.object({
        success: z16.boolean(),
        status: z16.nativeEnum(VerificationResultStatus),
        statusChanged: z16.boolean(),
        providerStatus: z16.string().optional(),
        message: z16.string().optional(),
        eventPublished: z16.boolean().optional()
      }),
      400: z16.object({ message: z16.string() }),
      401: z16.object({ message: z16.string() }),
      404: z16.object({ message: z16.string(), details: z16.string().optional() }),
      500: z16.object({ message: z16.string(), details: z16.string().optional() })
    },
    summary: "Job endpoint: Check ACH transaction status and orchestrate side effects"
  }
});

// src/http/bank-accounts.contract.ts
import { initContract as initContract17 } from "@ts-rest/core";
import { z as z17 } from "zod";
var c17 = initContract17();
var BankAccountDtoSchema = z17.object({
  id: z17.string(),
  customerId: z17.number(),
  accountName: z17.string().optional(),
  accountType: z17.enum(["checking", "savings"]).optional(),
  lastFour: z17.string().optional(),
  // Last 4 digits of account number (if available)
  isDefault: z17.boolean(),
  isDeleted: z17.boolean(),
  createdAt: z17.string(),
  // ISO date string
  updatedAt: z17.string()
  // ISO date string
});
var StoreBankAccountRequestSchema = z17.object({
  accountName: z17.string().min(1, "Account name is required"),
  accountNumber: z17.string().min(4, "Account number must be at least 4 digits"),
  routingNumber: z17.string().length(9, "Routing number must be exactly 9 digits"),
  accountType: z17.enum(["checking", "savings"], {
    errorMap: () => ({ message: "Account type must be checking or savings" })
  }),
  isDefault: z17.boolean().optional()
});
var SetDefaultBankAccountRequestSchema = z17.object({
  accountId: z17.string().uuid("Invalid account ID format")
});
var bankAccountsContract = c17.router({
  /**
   * List customer's bank accounts
   * Uses authenticated customer from request context
   */
  list: {
    method: "GET",
    path: "/api/bank-accounts",
    responses: {
      200: z17.object({ accounts: z17.array(BankAccountDtoSchema) }),
      401: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Get customer bank accounts"
  },
  /**
   * Store a new bank account
   * Creates account token via ACHPC and saves mapping
   */
  create: {
    method: "POST",
    path: "/api/bank-accounts",
    body: StoreBankAccountRequestSchema,
    responses: {
      201: z17.object({ account: BankAccountDtoSchema }),
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Store new bank account"
  },
  /**
   * Get specific bank account by ID
   * Validates ownership via authenticated customer
   */
  getById: {
    method: "GET",
    path: "/api/bank-accounts/:accountId",
    pathParams: z17.object({
      accountId: z17.string()
    }),
    responses: {
      200: z17.object({ account: BankAccountDtoSchema }),
      401: z17.object({ message: z17.string() }),
      403: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Get bank account by ID"
  },
  /**
   * Set a bank account as default
   */
  setDefault: {
    method: "PATCH",
    path: "/api/bank-accounts/:accountId/default",
    pathParams: z17.object({
      accountId: z17.string()
    }),
    body: z17.object({}),
    // Empty body, accountId comes from path
    responses: {
      200: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      403: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Set bank account as default"
  },
  /**
   * Remove a bank account
   */
  remove: {
    method: "DELETE",
    path: "/api/bank-accounts/:accountId",
    pathParams: z17.object({
      accountId: z17.string()
    }),
    body: z17.object({}),
    // Empty body
    responses: {
      200: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      403: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Remove bank account"
  }
});

// src/http/checkout.contract.ts
import { initContract as initContract18 } from "@ts-rest/core";
import {
  CheckoutRequestSchema,
  CheckoutResponseSchema,
  VerifyDestinationLicenseRequestSchema,
  VerifyDestinationLicenseResponseSchema
} from "@flote/types/checkout";
import {
  CreateDeliveryDestinationSchema,
  DeliveryDestinationSchema,
  DeliveryDestinationsResponseSchema
} from "@flote/types/delivery";
import { z as z18 } from "zod";
var c18 = initContract18();
var checkoutContract = c18.router({
  checkout: {
    method: "POST",
    path: "/api/checkout",
    body: CheckoutRequestSchema,
    headers: z18.object({
      "idempotency-key": z18.string().optional()
    }).optional(),
    responses: {
      200: CheckoutResponseSchema,
      400: z18.object({ message: z18.string() }),
      401: z18.object({ message: z18.string() }),
      403: z18.object({ message: z18.string() }),
      422: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Process checkout and create order"
  },
  getDeliveryDestinations: {
    method: "GET",
    path: "/api/checkout/delivery-destinations",
    responses: {
      200: DeliveryDestinationsResponseSchema,
      401: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Get available delivery destinations for the authenticated customer"
  },
  createDeliveryDestination: {
    method: "POST",
    path: "/api/checkout/delivery-destinations",
    body: CreateDeliveryDestinationSchema,
    responses: {
      201: DeliveryDestinationSchema,
      401: z18.object({ message: z18.string() }),
      404: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Create a delivery destination (org location) for the authenticated customer"
  },
  verifyDestinationLicense: {
    method: "POST",
    path: "/api/checkout/verify-destination-license",
    body: VerifyDestinationLicenseRequestSchema,
    responses: {
      200: VerifyDestinationLicenseResponseSchema,
      401: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Verify a Metrc license number and link it to a delivery location"
  }
});

// src/http/scheduled-checks.contract.ts
import { initContract as initContract19 } from "@ts-rest/core";
import { z as z19 } from "zod";
import {
  ScheduledTransactionSchema,
  ScheduledTransactionWithTransactionSchema,
  UpdateScheduledTransactionDtoSchema,
  FindScheduledTransactionsDtoSchema
} from "@flote/types/scheduled-transaction";
var c19 = initContract19();
var scheduledChecksContract = c19.router({
  findPending: {
    method: "GET",
    path: "/api/scheduled-checks/pending",
    query: FindScheduledTransactionsDtoSchema,
    responses: {
      200: z19.array(ScheduledTransactionWithTransactionSchema),
      400: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Find pending scheduled transaction checks with transaction data"
  },
  getById: {
    method: "GET",
    path: "/api/scheduled-checks/:id",
    pathParams: z19.object({
      id: z19.string().uuid()
    }),
    responses: {
      200: ScheduledTransactionSchema,
      404: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Get scheduled check by ID"
  },
  update: {
    method: "PATCH",
    path: "/api/scheduled-checks/:id",
    pathParams: z19.object({
      id: z19.string().uuid()
    }),
    body: UpdateScheduledTransactionDtoSchema,
    responses: {
      204: z19.void(),
      400: z19.object({ message: z19.string() }),
      404: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Update scheduled check status and metadata"
  }
});

// src/http/discount-codes.contract.ts
import { initContract as initContract20 } from "@ts-rest/core";
import { z as z20 } from "zod";
import {
  DiscountCodeSchema,
  CreateDiscountCodeDtoSchema,
  UpdateDiscountCodeDtoSchema,
  FindDiscountCodesDtoSchema,
  ValidateDiscountCodeDtoSchema,
  DiscountCodeValidationResultSchema,
  ApplyDiscountCodeDtoSchema
} from "@flote/types/discount-codes";
import {
  DiscountCodeRedemptionSchema,
  CustomerEligibilityResponseDtoSchema
} from "@flote/types/discount-code-redemptions";
var c20 = initContract20();
var discountCodesContract = c20.router({
  create: {
    method: "POST",
    path: "/api/discount-codes",
    body: CreateDiscountCodeDtoSchema,
    responses: {
      201: DiscountCodeSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      409: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Create a new discount code"
  },
  list: {
    method: "GET",
    path: "/api/discount-codes",
    query: FindDiscountCodesDtoSchema.optional(),
    responses: {
      200: z20.array(DiscountCodeSchema),
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "List discount codes with optional filters"
  },
  getById: {
    method: "GET",
    path: "/api/discount-codes/:id",
    pathParams: z20.object({ id: z20.string().uuid() }),
    responses: {
      200: DiscountCodeSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Get discount code by ID"
  },
  getByCode: {
    method: "GET",
    path: "/api/discount-codes/code/:code",
    pathParams: z20.object({ code: z20.string() }),
    responses: {
      200: DiscountCodeSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Get discount code by code"
  },
  update: {
    method: "PATCH",
    path: "/api/discount-codes/:id",
    pathParams: z20.object({ id: z20.string().uuid() }),
    body: UpdateDiscountCodeDtoSchema,
    responses: {
      200: z20.object({ success: z20.boolean() }),
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Update discount code"
  },
  delete: {
    method: "DELETE",
    path: "/api/discount-codes/:id",
    pathParams: z20.object({ id: z20.string().uuid() }),
    body: c20.noBody(),
    responses: {
      200: z20.object({ success: z20.boolean() }),
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Soft delete discount code"
  },
  validate: {
    method: "POST",
    path: "/api/discount-codes/validate",
    body: ValidateDiscountCodeDtoSchema,
    responses: {
      200: DiscountCodeValidationResultSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Validate a discount code against order criteria"
  },
  checkCustomerEligibility: {
    method: "GET",
    path: "/api/discount-codes/:discountCodeId/customers/:customerId/eligibility",
    pathParams: z20.object({
      discountCodeId: z20.string().uuid(),
      customerId: z20.coerce.number()
    }),
    responses: {
      200: CustomerEligibilityResponseDtoSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Check if a customer is eligible to use a discount code"
  },
  redeem: {
    method: "POST",
    path: "/api/discount-codes/redeem",
    body: ApplyDiscountCodeDtoSchema,
    responses: {
      201: DiscountCodeRedemptionSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      409: z20.object({ message: z20.string() }),
      422: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Redeem a discount code for an order"
  },
  getRedemptionById: {
    method: "GET",
    path: "/api/discount-code-redemptions/:id",
    pathParams: z20.object({ id: z20.string().uuid() }),
    responses: {
      200: DiscountCodeRedemptionSchema,
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Get discount code redemption by ID"
  },
  getRedemptionsByCode: {
    method: "GET",
    path: "/api/discount-codes/:discountCodeId/redemptions",
    pathParams: z20.object({ discountCodeId: z20.string().uuid() }),
    responses: {
      200: z20.array(DiscountCodeRedemptionSchema),
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Get all redemptions for a discount code"
  },
  getRedemptionsByCustomer: {
    method: "GET",
    path: "/api/customers/:customerId/discount-code-redemptions",
    pathParams: z20.object({ customerId: z20.coerce.number() }),
    responses: {
      200: z20.array(DiscountCodeRedemptionSchema),
      400: z20.object({ message: z20.string() }),
      401: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Get all discount code redemptions for a customer"
  }
});

// src/http/fulfillment-offers.contract.ts
import { initContract as initContract21 } from "@ts-rest/core";
import { z as z21 } from "zod";
import {
  FulfillmentOfferWithPartitionDtoSchema,
  FulfillmentOfferWithPartitionAndItemsDtoSchema,
  OfferResponseDtoSchema,
  ExpireOffersResponseDtoSchema,
  FulfillmentOfferStatusSchema,
  OrderPartitionDtoSchema,
  OrderPartitionFulfillmentTypeSchema,
  OrderPartitionFulfillmentStatusSchema,
  FulfillmentResultSchema,
  CarrierTrackingSnapshotSchema
} from "@flote/types/delivery";
var c21 = initContract21();
var fulfillmentOffersContract = c21.router({
  // =============================================================================
  // Brand-Scoped Offer Queries
  // =============================================================================
  /**
   * Get fulfillment offers for a brand.
   * Used by supplier portal to show pending self-delivery offers.
   */
  getOffersForBrand: {
    method: "GET",
    path: "/api/brands/:brandId/fulfillment-offers",
    pathParams: z21.object({ brandId: z21.string().uuid() }),
    query: z21.object({
      status: FulfillmentOfferStatusSchema.optional()
    }),
    responses: {
      200: z21.array(FulfillmentOfferWithPartitionDtoSchema),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get fulfillment offers for a brand"
  },
  /**
   * Get fulfillment offers for a brand with partition items.
   * Includes line item details (quantity, price, product name) for each offer.
   * Used by supplier portal to display full order contents for decision-making.
   */
  getOffersForBrandWithItems: {
    method: "GET",
    path: "/api/brands/:brandId/fulfillment-offers-with-items",
    pathParams: z21.object({ brandId: z21.string().uuid() }),
    query: z21.object({
      status: FulfillmentOfferStatusSchema.optional()
    }),
    responses: {
      200: z21.array(FulfillmentOfferWithPartitionAndItemsDtoSchema),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get fulfillment offers for a brand with partition line items"
  },
  /**
   * Get order partitions for a brand.
   * Used by supplier portal to show accepted deliveries (brand_driver partitions).
   */
  getPartitionsForBrand: {
    method: "GET",
    path: "/api/brands/:brandId/order-partitions",
    pathParams: z21.object({ brandId: z21.string().uuid() }),
    query: z21.object({
      fulfillmentType: OrderPartitionFulfillmentTypeSchema.optional(),
      fulfillmentStatus: OrderPartitionFulfillmentStatusSchema.optional(),
      productSku: z21.string().optional(),
      trackingId: z21.string().optional(),
      search: z21.string().optional(),
      stockLocationId: z21.string().uuid().optional()
    }),
    responses: {
      200: z21.array(OrderPartitionDtoSchema),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get order partitions for a brand with optional filters"
  },
  /**
   * Manually fulfill an order partition.
   * Used by supplier portal for manual delivery confirmation (fallback if webhook fails).
   * Releases reserved inventory and creates fulfillment audit records.
   * Idempotent - safe to call multiple times.
   */
  fulfillPartition: {
    method: "POST",
    path: "/api/brands/:brandId/order-partitions/:partitionId/fulfill",
    pathParams: z21.object({
      brandId: z21.string().uuid(),
      partitionId: z21.string().uuid()
    }),
    body: z21.object({
      fulfilledQuantities: z21.record(z21.string(), z21.number().int().positive()).optional()
    }),
    responses: {
      200: FulfillmentResultSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Manually fulfill an order partition and release inventory"
  },
  // =============================================================================
  // Mail Carrier Shipping Actions
  // =============================================================================
  /**
   * Ship a mail-carrier partition by setting carrier and tracking number.
   * Only valid for partitions with fulfillmentType='mail_carrier' and status='accepted'.
   */
  shipPartition: {
    method: "POST",
    path: "/api/brands/:brandId/order-partitions/:partitionId/ship",
    pathParams: z21.object({
      brandId: z21.string().uuid(),
      partitionId: z21.string().uuid()
    }),
    body: z21.object({
      shippingCarrier: z21.enum(["usps", "ups", "fedex"]),
      carrierTrackingNumber: z21.string().min(1)
    }),
    responses: {
      200: OrderPartitionDtoSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      409: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Ship a mail-carrier partition with carrier and tracking number"
  },
  /**
   * Mark a shipped partition as delivered.
   * Only valid for partitions with fulfillmentStatus='shipped'.
   * Creates fulfillment records and marks completed.
   */
  markDelivered: {
    method: "POST",
    path: "/api/brands/:brandId/order-partitions/:partitionId/mark-delivered",
    pathParams: z21.object({
      brandId: z21.string().uuid(),
      partitionId: z21.string().uuid()
    }),
    body: z21.object({}),
    responses: {
      200: OrderPartitionDtoSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Mark a shipped partition as delivered"
  },
  /**
   * Get live carrier tracking for a shipped mail-carrier partition.
   * Fetches current tracking status, timeline events, and estimated delivery from EasyPost.
   * Requires the partition to have a registered EasyPost tracker (easypostTrackerId).
   */
  getPartitionTracking: {
    method: "GET",
    path: "/api/brands/:brandId/order-partitions/:partitionId/tracking",
    pathParams: z21.object({
      brandId: z21.string().uuid(),
      partitionId: z21.string().uuid()
    }),
    responses: {
      200: CarrierTrackingSnapshotSchema,
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get live carrier tracking for a shipped mail-carrier partition"
  },
  // =============================================================================
  // Offer Response Actions
  // =============================================================================
  /**
   * Accept a fulfillment offer (brand will self-deliver).
   * Sets partition to brand_driver fulfillment with 4% spread.
   */
  acceptOffer: {
    method: "POST",
    path: "/api/fulfillment-offers/:id/accept",
    pathParams: z21.object({ id: z21.string().uuid() }),
    body: c21.noBody(),
    responses: {
      200: OfferResponseDtoSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      409: z21.object({ message: z21.string() }),
      410: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Accept a fulfillment offer (brand self-delivers)"
  },
  /**
   * Decline a fulfillment offer (Flote will deliver).
   * Sets partition to flote_driver fulfillment with 10% spread.
   */
  declineOffer: {
    method: "POST",
    path: "/api/fulfillment-offers/:id/decline",
    pathParams: z21.object({ id: z21.string().uuid() }),
    body: z21.object({
      reason: z21.string().optional()
    }),
    responses: {
      200: OfferResponseDtoSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      403: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      409: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Decline a fulfillment offer (Flote delivers)"
  },
  // =============================================================================
  // Job Endpoints (Internal)
  // =============================================================================
  /**
   * Expire all pending offers past deadline.
   * Called by scheduled job every minute.
   * Auto-assigns expired partitions to Flote with 10% spread.
   */
  expireOffers: {
    method: "POST",
    path: "/api/jobs/fulfillment-offers/expire",
    body: c21.noBody(),
    responses: {
      200: ExpireOffersResponseDtoSchema,
      401: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Expire pending fulfillment offers past deadline (job endpoint)"
  }
});

// src/http/inventory.contract.ts
import { initContract as initContract22 } from "@ts-rest/core";
import { z as z22 } from "zod";
import {
  StockLocationDetailDtoSchema,
  InventoryListingQuerySchema,
  InventoryListingResponseSchema,
  UpdateInventoryLevelDtoSchema,
  InventoryLevelDtoSchema,
  AddProductToInventoryInputSchema,
  TransferListingQuerySchema,
  TransferListingResponseSchema,
  InventoryTransferListingDtoSchema,
  CreateInventoryTransferInputSchema,
  UpdateTransferStatusInputSchema,
  BatchListingQuerySchema,
  BatchListingResponseSchema,
  InventoryBatchListingDtoSchema,
  ReceiveBatchInputSchema,
  UpdateInventoryBatchInputSchema
} from "@flote/types/inventory";
var c22 = initContract22();
var inventoryContract = c22.router({
  // =============================================================================
  // Stock Location Endpoints (for supplier portal)
  // =============================================================================
  /**
   * Get stock locations accessible to a supplier with full details.
   * Returns locations with address info and supplier's permissions.
   */
  getSupplierStockLocations: {
    method: "GET",
    path: "/api/suppliers/:supplierId/inventory/stock-locations",
    pathParams: z22.object({ supplierId: z22.string().uuid() }),
    responses: {
      200: z22.array(StockLocationDetailDtoSchema),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get stock locations accessible to supplier with details"
  },
  // =============================================================================
  // Inventory Listing Endpoints
  // =============================================================================
  /**
   * Get inventory at a stock location filtered by supplier's brands.
   * Returns paginated list of inventory items with quantities.
   */
  getStockLocationInventory: {
    method: "GET",
    path: "/api/stock-locations/:locationId/inventory",
    pathParams: z22.object({ locationId: z22.string().uuid() }),
    query: InventoryListingQuerySchema,
    responses: {
      200: InventoryListingResponseSchema,
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get inventory at a stock location (filtered by supplier brands)"
  },
  // =============================================================================
  // Inventory Level Endpoints (for Phase 4)
  // =============================================================================
  /**
   * Update inventory level quantity.
   * Requires supplier to have canEdit permission on the location.
   */
  updateInventoryLevel: {
    method: "PATCH",
    path: "/api/inventory-levels/:id",
    pathParams: z22.object({ id: z22.string().uuid() }),
    body: UpdateInventoryLevelDtoSchema,
    query: z22.object({
      // Required for authorization - must verify supplier has edit access
      supplierId: z22.string().uuid()
    }),
    responses: {
      200: InventoryLevelDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Update inventory level stocked quantity"
  },
  /**
   * Add a product to inventory at a specific stock location.
   * Creates inventory item and level if they don't exist.
   * Requires supplier to have canEdit permission on the location.
   */
  addProductToLocation: {
    method: "POST",
    path: "/api/stock-locations/:locationId/inventory",
    pathParams: z22.object({ locationId: z22.string().uuid() }),
    body: AddProductToInventoryInputSchema,
    query: z22.object({
      // Required for authorization - must verify supplier has edit access
      supplierId: z22.string().uuid()
    }),
    responses: {
      201: InventoryLevelDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      409: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Add a product to inventory at a stock location"
  },
  // =============================================================================
  // Inventory Transfer Endpoints
  // =============================================================================
  /**
   * List inventory transfers for a supplier.
   * Returns transfers where supplier has access to both locations.
   */
  listTransfers: {
    method: "GET",
    path: "/api/suppliers/:supplierId/inventory/transfers",
    pathParams: z22.object({ supplierId: z22.string().uuid() }),
    query: TransferListingQuerySchema,
    responses: {
      200: TransferListingResponseSchema,
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "List inventory transfers for supplier"
  },
  /**
   * Get a single transfer by ID.
   * Returns transfer with enriched data (locations, users, product info).
   */
  getTransfer: {
    method: "GET",
    path: "/api/inventory/transfers/:id",
    pathParams: z22.object({ id: z22.string().uuid() }),
    query: z22.object({
      supplierId: z22.string().uuid()
    }),
    responses: {
      200: InventoryTransferListingDtoSchema,
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get a single inventory transfer"
  },
  /**
   * Create a new inventory transfer.
   * Supplier must have canEdit on both source and destination locations.
   * Set instant=true to complete transfer immediately without shipping flow.
   */
  createTransfer: {
    method: "POST",
    path: "/api/inventory/transfers",
    body: CreateInventoryTransferInputSchema,
    query: z22.object({
      supplierId: z22.string().uuid()
    }),
    responses: {
      201: InventoryTransferListingDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      422: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Create a new inventory transfer"
  },
  /**
   * Update transfer status (ship, receive, or cancel).
   * - Ship: Decrements source inventory, sets shipped_at
   * - Receive: Increments destination inventory, sets received_at
   * - Cancel: Restores source if shipped, sets cancelled_at
   */
  updateTransferStatus: {
    method: "PATCH",
    path: "/api/inventory/transfers/:id/status",
    pathParams: z22.object({ id: z22.string().uuid() }),
    body: UpdateTransferStatusInputSchema,
    query: z22.object({
      supplierId: z22.string().uuid()
    }),
    responses: {
      200: InventoryTransferListingDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      409: z22.object({ message: z22.string() }),
      422: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Update transfer status"
  },
  // =============================================================================
  // Inventory Batch Endpoints (FIFO/Lot Tracking)
  // =============================================================================
  /**
   * List batches at a stock location.
   * Returns paginated list with product/brand info for display.
   * Ordered by received_date ASC (FIFO order) by default.
   */
  listBatches: {
    method: "GET",
    path: "/api/stock-locations/:locationId/batches",
    pathParams: z22.object({ locationId: z22.string().uuid() }),
    query: BatchListingQuerySchema.omit({ stockLocationId: true }),
    responses: {
      200: BatchListingResponseSchema,
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "List inventory batches at a stock location"
  },
  /**
   * Receive a new batch of inventory.
   * Creates batch record and increments inventory_level.stocked_quantity.
   * Requires supplier to have canEdit permission on the location.
   */
  receiveBatch: {
    method: "POST",
    path: "/api/stock-locations/:locationId/batches",
    pathParams: z22.object({ locationId: z22.string().uuid() }),
    body: ReceiveBatchInputSchema.omit({ stockLocationId: true }),
    query: z22.object({
      supplierId: z22.string().uuid()
    }),
    responses: {
      201: InventoryBatchListingDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      409: z22.object({ message: z22.string() }),
      // Duplicate batch/lot at same item+location
      500: z22.object({ message: z22.string() })
    },
    summary: "Receive a new batch of inventory"
  },
  /**
   * Update an existing batch.
   * Can update batch/lot numbers, dates, METRC tag.
   * Cannot change quantities directly - use adjustments.
   */
  // =============================================================================
  // Metrc Integration Endpoints
  // =============================================================================
  /**
   * Get total inventory for a specific item at a Metrc-licensed facility.
   * Pages through all active packages and sums quantities for the matching item.
   */
  getMetrcItemInventory: {
    method: "GET",
    path: "/api/inventory/metrc/item",
    query: z22.object({
      licenseNumber: z22.string().min(1),
      itemId: z22.coerce.number().int().positive().optional(),
      itemName: z22.string().min(1).optional(),
      unitWeight: z22.coerce.number().positive().optional(),
      unitsPerCase: z22.coerce.number().int().positive().optional()
    }).refine((data) => data.itemId || data.itemName, {
      message: "Either itemId or itemName must be provided"
    }),
    responses: {
      200: z22.object({
        itemId: z22.number().nullable(),
        itemName: z22.string(),
        licenseNumber: z22.string(),
        totalQuantity: z22.number(),
        unitOfMeasure: z22.string().nullable(),
        caseBreakdown: z22.object({
          unitWeight: z22.number(),
          unitsPerCase: z22.number(),
          caseWeight: z22.number(),
          completeCases: z22.number(),
          bulkCases: z22.number(),
          masterCases: z22.number(),
          loosePackages: z22.number()
        }).nullable(),
        packages: z22.array(z22.object({
          label: z22.string().nullable(),
          quantity: z22.number().nullable(),
          location: z22.string().nullable(),
          packagedDate: z22.string().nullable(),
          labTestingState: z22.string().nullable()
        }))
      }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get total Metrc inventory for a specific item at a license"
  },
  /**
   * Get all unique items across active packages at a Metrc license.
   * Returns item IDs, names, categories, and aggregate quantities.
   */
  getMetrcItemsAtLocation: {
    method: "GET",
    path: "/api/inventory/metrc/items",
    query: z22.object({
      licenseNumber: z22.string().min(1)
    }),
    responses: {
      200: z22.object({
        licenseNumber: z22.string(),
        items: z22.array(z22.object({
          itemId: z22.number(),
          itemName: z22.string(),
          productCategoryName: z22.string().nullable(),
          totalQuantity: z22.number(),
          unitOfMeasure: z22.string().nullable(),
          packageCount: z22.number()
        })),
        totalPackages: z22.number()
      }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get all unique Metrc items at a license"
  },
  updateBatch: {
    method: "PATCH",
    path: "/api/inventory/batches/:id",
    pathParams: z22.object({ id: z22.string().uuid() }),
    body: UpdateInventoryBatchInputSchema.omit({ quantity: true, reservedQuantity: true }),
    query: z22.object({
      supplierId: z22.string().uuid()
    }),
    responses: {
      200: InventoryBatchListingDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Update batch metadata (not quantities)"
  },
  // =============================================================================
  // Metrc Sync Endpoints
  // =============================================================================
  /**
   * Trigger a Metrc inventory sync.
   * Syncs Metrc package quantities to local inventory levels.
   * Requires flote_admin or inventory:edit permission.
   */
  triggerMetrcSync: {
    method: "POST",
    path: "/api/inventory/metrc-sync",
    body: z22.object({
      mode: z22.enum(["full", "delta"])
    }),
    responses: {
      200: z22.object({
        success: z22.boolean(),
        locationsProcessed: z22.number().int(),
        itemsUpdated: z22.number().int(),
        itemsSkipped: z22.number().int(),
        errors: z22.number().int(),
        durationMs: z22.number().int(),
        locationResults: z22.array(z22.object({
          locationId: z22.string(),
          locationName: z22.string(),
          licenseNumber: z22.string(),
          packagesScanned: z22.number().int(),
          uniqueItems: z22.number().int(),
          itemsMatched: z22.number().int(),
          itemsSkipped: z22.number().int(),
          errors: z22.number().int()
        }))
      }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Trigger Metrc inventory sync (admin or inventory:edit)"
  }
});

// src/http/inventory-access.contract.ts
import { initContract as initContract23 } from "@ts-rest/core";
import { z as z23 } from "zod";
import {
  StockLocationAccessResponseSchema,
  StockLocationActivityResponseSchema,
  StockLocationActivityQuerySchema
} from "@flote/types/inventory";
var c23 = initContract23();
var inventoryAccessContract = c23.router({
  /**
   * Get users who have access to a stock location.
   * flote_admin: See ALL users with access (across all suppliers)
   * Supplier users: Only see users from their OWN supplier
   */
  getStockLocationAccess: {
    method: "GET",
    path: "/api/stock-locations/:locationId/access",
    pathParams: z23.object({ locationId: z23.string().uuid() }),
    query: z23.object({
      supplierId: z23.string().uuid().optional()
    }),
    responses: {
      200: StockLocationAccessResponseSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get users with access to a stock location"
  },
  /**
   * Get recent inventory activity (adjustments) at a stock location.
   * Returns adjustments with user attribution and product context.
   */
  getStockLocationActivity: {
    method: "GET",
    path: "/api/stock-locations/:locationId/activity",
    pathParams: z23.object({ locationId: z23.string().uuid() }),
    query: StockLocationActivityQuerySchema.extend({
      supplierId: z23.string().uuid().optional()
    }),
    responses: {
      200: StockLocationActivityResponseSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get recent inventory activity at a stock location"
  }
});

// src/http/product-management.contract.ts
import { initContract as initContract24 } from "@ts-rest/core";
import { z as z24 } from "zod";
import {
  UpdateProductInfoInputSchema,
  UploadProductImageDataInputSchema,
  ProductAuditQuerySchema,
  ProductAuditResponseSchema,
  ProductEditorsResponseSchema,
  ProductVariantsResponseSchema,
  UpdateProductVariantInputSchema,
  UpdateProductVariantResponseSchema,
  AddProductVariantInputSchema,
  AddProductVariantResponseSchema,
  DeleteProductVariantResponseSchema,
  AddProductImageInputSchema,
  ReorderProductGalleryInputSchema,
  DeleteProductGalleryImageResponseSchema,
  ProductImageDtoSchema
} from "@flote/types/product";
import { ProductFileDtoSchema } from "@flote/types/product";
var c24 = initContract24();
var UpdateProductResponseSchema = z24.object({
  id: z24.string().uuid(),
  title: z24.string(),
  description: z24.string().nullable(),
  thumbnail: z24.string().nullable(),
  updatedAt: z24.string().datetime()
});
var UploadProductImageResponseSchema = z24.object({
  id: z24.string().uuid(),
  thumbnail: z24.string().url(),
  updatedAt: z24.string().datetime()
});
var DeleteImageResponseSchema = z24.object({
  id: z24.string().uuid(),
  thumbnail: z24.null(),
  updatedAt: z24.string().datetime()
});
var UploadProductFileInputSchema = z24.object({
  fileData: z24.string(),
  // Base64 encoded file data
  fileName: z24.string().max(255),
  title: z24.string().max(255),
  contentType: z24.string()
});
var UploadedProductFileResponseSchema = z24.object({
  id: z24.string().uuid(),
  productId: z24.string().uuid(),
  file: ProductFileDtoSchema
});
var DeleteProductFileResponseSchema = z24.object({
  success: z24.boolean(),
  deletedFileId: z24.string().uuid()
});
var ErrorResponseSchema = z24.object({ message: z24.string() });
var productManagementContract = c24.router({
  /**
   * Update product info (title, description).
   * Requires PRODUCTS_EDIT permission.
   */
  updateProductInfo: {
    method: "PATCH",
    path: "/api/products/:productId",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: UpdateProductInfoInputSchema,
    responses: {
      200: UpdateProductResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Update product info (title, description)"
  },
  /**
   * Upload or replace product image.
   * Requires PRODUCTS_EDIT permission.
   */
  uploadProductImage: {
    method: "POST",
    path: "/api/products/:productId/image",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: UploadProductImageDataInputSchema,
    responses: {
      200: UploadProductImageResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Upload or replace product image"
  },
  /**
   * Delete product image.
   * Requires PRODUCTS_EDIT permission.
   */
  deleteProductImage: {
    method: "DELETE",
    path: "/api/products/:productId/image",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: z24.undefined(),
    responses: {
      200: DeleteImageResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Delete product image"
  },
  /**
   * Get files attached to a product.
   */
  getProductFiles: {
    method: "GET",
    path: "/api/products/:productId/files",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    responses: {
      200: z24.object({
        productId: z24.string().uuid(),
        files: z24.array(ProductFileDtoSchema)
      }),
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Get files attached to a product"
  },
  /**
   * Upload a file to attach to a product.
   * Requires PRODUCTS_EDIT permission.
   */
  uploadProductFile: {
    method: "POST",
    path: "/api/products/:productId/files",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: UploadProductFileInputSchema,
    responses: {
      201: UploadedProductFileResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Upload a file to attach to a product"
  },
  /**
   * Remove a file from a product.
   * Requires PRODUCTS_EDIT permission.
   */
  removeProductFile: {
    method: "DELETE",
    path: "/api/products/:productId/files/:fileId",
    pathParams: z24.object({
      productId: z24.string().uuid(),
      fileId: z24.string().uuid()
    }),
    body: z24.undefined(),
    responses: {
      200: DeleteProductFileResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Remove a file from a product"
  },
  /**
   * Get product variants with pricing.
   */
  getProductVariants: {
    method: "GET",
    path: "/api/products/:productId/variants",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    responses: {
      200: ProductVariantsResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Get product variants with pricing"
  },
  /**
   * Update a product variant.
   * Requires PRODUCTS_EDIT permission.
   */
  updateProductVariant: {
    method: "PATCH",
    path: "/api/products/:productId/variants/:variantId",
    pathParams: z24.object({
      productId: z24.string().uuid(),
      variantId: z24.string().uuid()
    }),
    body: UpdateProductVariantInputSchema,
    responses: {
      200: UpdateProductVariantResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Update a product variant"
  },
  /**
   * Add a new variant to an existing product.
   * Requires PRODUCTS_EDIT permission.
   */
  addProductVariant: {
    method: "POST",
    path: "/api/products/:productId/variants",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: AddProductVariantInputSchema,
    responses: {
      201: AddProductVariantResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Add a new variant to a product"
  },
  /**
   * Delete a product variant.
   * Cannot delete the last variant (product must have ≥1).
   * Requires PRODUCTS_EDIT permission.
   */
  deleteProductVariant: {
    method: "DELETE",
    path: "/api/products/:productId/variants/:variantId",
    pathParams: z24.object({
      productId: z24.string().uuid(),
      variantId: z24.string().uuid()
    }),
    body: z24.undefined(),
    responses: {
      200: DeleteProductVariantResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Delete a product variant (cannot delete last variant)"
  },
  /**
   * Add an image to the product gallery.
   * Requires PRODUCTS_EDIT permission.
   */
  addProductGalleryImage: {
    method: "POST",
    path: "/api/products/:productId/images",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: AddProductImageInputSchema,
    responses: {
      201: ProductImageDtoSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Add an image to the product gallery"
  },
  /**
   * Remove an image from the product gallery.
   * Requires PRODUCTS_EDIT permission.
   */
  deleteProductGalleryImage: {
    method: "DELETE",
    path: "/api/products/:productId/images/:imageId",
    pathParams: z24.object({
      productId: z24.string().uuid(),
      imageId: z24.string().uuid()
    }),
    body: z24.undefined(),
    responses: {
      200: DeleteProductGalleryImageResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Remove an image from the product gallery"
  },
  /**
   * Reorder product gallery images.
   * Requires PRODUCTS_EDIT permission.
   */
  reorderProductGalleryImages: {
    method: "PATCH",
    path: "/api/products/:productId/images/reorder",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    body: ReorderProductGalleryInputSchema,
    responses: {
      200: z24.object({ success: z24.boolean() }),
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Reorder product gallery images"
  },
  /**
   * Get audit log for a product (edit history).
   * Returns chronological list of changes with user attribution.
   */
  getProductAuditLog: {
    method: "GET",
    path: "/api/products/:productId/audit",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    query: ProductAuditQuerySchema,
    responses: {
      200: ProductAuditResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Get product edit history (audit log)"
  },
  /**
   * Get users who can edit this product.
   * Returns users with PRODUCTS_EDIT permission for the product's brand.
   */
  getProductEditors: {
    method: "GET",
    path: "/api/products/:productId/editors",
    pathParams: z24.object({ productId: z24.string().uuid() }),
    responses: {
      200: ProductEditorsResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Get users who can edit this product"
  }
});

// src/http/permissions.contract.ts
import { initContract as initContract25 } from "@ts-rest/core";
import { z as z25 } from "zod";
var c25 = initContract25();
var PermissionSchema = z25.string();
var permissionsContract = c25.router({
  /**
   * Get permissions for a role.
   * Returns array of permission strings mapped to the role.
   */
  getForRole: {
    method: "GET",
    path: "/api/permissions/role/:role",
    pathParams: z25.object({
      role: z25.string()
    }),
    responses: {
      200: z25.array(PermissionSchema),
      400: z25.object({ message: z25.string() }),
      401: z25.object({ message: z25.string() }),
      404: z25.object({ message: z25.string() }),
      500: z25.object({ message: z25.string() })
    },
    summary: "Get permissions for a role"
  },
  /**
   * Get permissions for the current authenticated user.
   * Returns permissions across all roles assigned to the user.
   */
  getForCurrentUser: {
    method: "GET",
    path: "/api/permissions/me",
    responses: {
      200: z25.object({
        permissions: z25.array(PermissionSchema),
        roles: z25.array(z25.string())
      }),
      401: z25.object({ message: z25.string() }),
      500: z25.object({ message: z25.string() })
    },
    summary: "Get permissions for current user"
  },
  /**
   * Replace all permissions for a role.
   * Requires portal_users:manage permission (flote_admin only).
   */
  updateForRole: {
    method: "PUT",
    path: "/api/permissions/role/:role",
    pathParams: z25.object({
      role: z25.string()
    }),
    body: z25.object({
      permissions: z25.array(PermissionSchema)
    }),
    responses: {
      200: z25.array(PermissionSchema),
      400: z25.object({ message: z25.string() }),
      401: z25.object({ message: z25.string() }),
      403: z25.object({ message: z25.string() }),
      404: z25.object({ message: z25.string() }),
      500: z25.object({ message: z25.string() })
    },
    summary: "Update permissions for a role"
  }
});

// src/http/portal-admin.contract.ts
import { initContract as initContract26 } from "@ts-rest/core";
import { z as z26 } from "zod";
import { SupplierProductListingDtoSchema } from "@flote/types/product";
import { StockLocationDetailDtoSchema as StockLocationDetailDtoSchema2 } from "@flote/types/inventory";
import {
  OrderPartitionFulfillmentStatusSchema as OrderPartitionFulfillmentStatusSchema2,
  OrderPartitionFulfillmentTypeSchema as OrderPartitionFulfillmentTypeSchema2,
  OrderPartitionPreparationStatusSchema
} from "@flote/types/delivery";
import {
  TransferTemplateDtoSchema,
  TransferTemplateReadinessDtoSchema,
  TransferTemplateLayoverLegInputSchema,
  TransferTemplateLocalLayoverAuditInputSchema,
  TransferTemplateBatchStatusItemSchema
} from "@flote/types/compliance";
var c26 = initContract26();
var AdminProductListingDtoSchema = SupplierProductListingDtoSchema.extend({
  supplierId: z26.string().uuid().nullable(),
  supplierName: z26.string().nullable()
});
var AdminProductListingResponseSchema = z26.object({
  products: z26.array(AdminProductListingDtoSchema),
  total: z26.number().int(),
  page: z26.number().int(),
  pageSize: z26.number().int(),
  hasMore: z26.boolean()
});
var AdminStockLocationDtoSchema = StockLocationDetailDtoSchema2.extend({
  supplierId: z26.string().uuid().nullable(),
  supplierName: z26.string().nullable()
});
var AdminStockLocationListResponseSchema = z26.object({
  locations: z26.array(AdminStockLocationDtoSchema),
  total: z26.number().int(),
  page: z26.number().int(),
  pageSize: z26.number().int(),
  hasMore: z26.boolean()
});
var AdminPartitionListItemSchema = z26.object({
  id: z26.string().uuid(),
  orderId: z26.string().uuid().nullable(),
  b2bwaveOrderId: z26.string(),
  brandId: z26.string().uuid(),
  brandName: z26.string().optional(),
  brandRealm: z26.enum(["cannabis", "hemp", "general"]).optional(),
  trackingId: z26.string(),
  portionSubtotal: z26.number(),
  portionTotal: z26.number(),
  fulfillmentType: OrderPartitionFulfillmentTypeSchema2.nullable(),
  fulfillmentStatus: OrderPartitionFulfillmentStatusSchema2,
  preparationStatus: OrderPartitionPreparationStatusSchema,
  paymentMethod: z26.string().nullable(),
  stockLocationId: z26.string().uuid().nullable(),
  stockLocationName: z26.string().optional(),
  onfleetTaskId: z26.string().nullable(),
  spreadRate: z26.number().nullable(),
  spreadAmount: z26.number().nullable(),
  hasSignature: z26.boolean(),
  photoCount: z26.number().int().nonnegative(),
  destinationOrganizationLocationId: z26.string().uuid().nullable().optional(),
  destinationComplianceLicenseId: z26.string().uuid().nullable().optional(),
  shippingCarrier: z26.string().nullable(),
  carrierTrackingNumber: z26.string().nullable(),
  shippedAt: z26.string().nullable(),
  easypostTrackerId: z26.string().nullable(),
  metadata: z26.record(z26.unknown()),
  createdAt: z26.string(),
  updatedAt: z26.string(),
  customerName: z26.string().optional(),
  companyName: z26.string().optional(),
  customerLicenseNumber: z26.string().optional(),
  totalQuantity: z26.number().int().nonnegative().optional(),
  itemCount: z26.number().int().nonnegative().optional()
});
var AdminPartitionItemBatchAllocationSchema = z26.object({
  id: z26.string().uuid(),
  inventoryBatchId: z26.string().uuid(),
  reservedQuantity: z26.number().int().nonnegative(),
  releasedQuantity: z26.number().int().nonnegative(),
  consumedQuantity: z26.number().int().nonnegative(),
  remainingQuantity: z26.number().int().nonnegative(),
  metrcPackageTag: z26.string().nullable(),
  batchNumber: z26.string().nullable(),
  lotNumber: z26.string().nullable(),
  receivedDate: z26.string(),
  expiryDate: z26.string().nullable(),
  reservedAt: z26.string(),
  releasedAt: z26.string().nullable(),
  consumedAt: z26.string().nullable()
});
var AdminPartitionItemDetailSchema = z26.object({
  id: z26.string().uuid(),
  productVariantId: z26.string().uuid(),
  productId: z26.string().uuid().optional(),
  productName: z26.string().optional(),
  productCode: z26.string().optional(),
  productThumbnail: z26.string().optional(),
  quantity: z26.number().int(),
  reservedQuantity: z26.number().int(),
  fulfilledQuantity: z26.number().int(),
  unitPrice: z26.number(),
  lineTotal: z26.number(),
  batchAllocations: z26.array(AdminPartitionItemBatchAllocationSchema)
});
var AdminPartitionDetailSchema = AdminPartitionListItemSchema.extend({
  items: z26.array(AdminPartitionItemDetailSchema),
  customerName: z26.string().optional(),
  customerPhone: z26.string().optional(),
  customerAddress: z26.string().optional()
});
var AdminPartitionListResponseSchema = z26.object({
  partitions: z26.array(AdminPartitionListItemSchema),
  nextCursor: z26.string().optional()
});
var CreateTestOrderItemSchema = z26.object({
  productId: z26.string().uuid(),
  productName: z26.string(),
  productCode: z26.string(),
  brandId: z26.string().uuid(),
  quantity: z26.number().int().positive(),
  unitPrice: z26.number().nonnegative()
});
var CreateTestOrderInputSchema = z26.object({
  customerId: z26.string().uuid(),
  items: z26.array(CreateTestOrderItemSchema).min(1),
  notes: z26.string().optional()
});
var TestOrderListItemSchema = z26.object({
  id: z26.string().uuid(),
  displayId: z26.number().int(),
  externalId: z26.string().nullable(),
  customerName: z26.string().nullable(),
  companyName: z26.string().nullable(),
  status: z26.string(),
  itemCount: z26.number().int(),
  total: z26.number(),
  partitionCount: z26.number().int(),
  createdAt: z26.string()
});
var TestOrderListResponseSchema = z26.object({
  orders: z26.array(TestOrderListItemSchema),
  total: z26.number().int()
});
var TestOrderDetailSchema = z26.object({
  id: z26.string().uuid(),
  displayId: z26.number().int(),
  externalId: z26.string().nullable(),
  customerName: z26.string().nullable(),
  companyName: z26.string().nullable(),
  email: z26.string().nullable(),
  status: z26.string(),
  paymentMethod: z26.string(),
  items: z26.array(z26.object({
    id: z26.string().uuid(),
    productName: z26.string().nullable(),
    productCode: z26.string().nullable(),
    quantity: z26.number().int(),
    unitPrice: z26.number(),
    lineTotal: z26.number()
  })),
  totals: z26.object({
    subtotal: z26.number(),
    total: z26.number(),
    itemCount: z26.number().int()
  }),
  partitions: z26.array(z26.object({
    id: z26.string().uuid(),
    brandId: z26.string().uuid(),
    brandName: z26.string().optional(),
    trackingId: z26.string(),
    portionTotal: z26.number(),
    fulfillmentStatus: z26.string(),
    itemCount: z26.number().int()
  })),
  createdAt: z26.string()
});
var CustomerSearchResultSchema = z26.object({
  id: z26.string().uuid(),
  externalId: z26.string().nullable(),
  companyName: z26.string().nullable(),
  contactName: z26.string().nullable(),
  email: z26.string().nullable()
});
var OrderExportRowSchema = z26.object({
  orderId: z26.string(),
  trackingId: z26.string(),
  orderDate: z26.string(),
  preparationStatus: z26.string(),
  fulfillmentStatus: z26.string(),
  fulfillmentType: z26.string().nullable(),
  customerCompany: z26.string().nullable(),
  customerName: z26.string().nullable(),
  customerLicense: z26.string().nullable(),
  brandName: z26.string().nullable(),
  stockLocationName: z26.string().nullable(),
  paymentMethod: z26.string().nullable(),
  productCode: z26.string().nullable(),
  productName: z26.string().nullable(),
  quantity: z26.number(),
  unitPrice: z26.number(),
  lineTotal: z26.number(),
  orderSubtotal: z26.number(),
  orderTotal: z26.number()
});
var OrderExportResponseSchema = z26.object({
  rows: z26.array(OrderExportRowSchema),
  partitionCount: z26.number().int()
});
var portalAdminContract = c26.router({
  // ===========================================================================
  // Order Partition Endpoints
  // ===========================================================================
  /**
   * Get all order partitions with enriched data (brand names, stock locations).
   * Supports filtering by status, type, brand, and date range.
   */
  getAllOrderPartitions: {
    method: "GET",
    path: "/api/portal-admin/order-partitions",
    query: z26.object({
      fulfillmentStatus: OrderPartitionFulfillmentStatusSchema2.optional(),
      preparationStatus: OrderPartitionPreparationStatusSchema.optional(),
      fulfillmentType: OrderPartitionFulfillmentTypeSchema2.optional(),
      brandId: z26.string().uuid().optional(),
      trackingId: z26.string().optional(),
      productSku: z26.string().optional(),
      search: z26.string().optional(),
      stockLocationId: z26.string().uuid().optional(),
      fromDate: z26.string().optional(),
      toDate: z26.string().optional(),
      limit: z26.coerce.number().int().positive().max(100).optional().default(25),
      cursor: z26.string().optional()
    }),
    responses: {
      200: AdminPartitionListResponseSchema,
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Get all order partitions (flote_admin only)"
  },
  /**
   * Export order partitions as denormalized rows (one row per line item).
   * Used for CSV export with optional date range filtering.
   */
  exportOrderPartitions: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/export",
    query: z26.object({
      fromDate: z26.string().optional(),
      toDate: z26.string().optional(),
      brandId: z26.string().uuid().optional()
    }),
    responses: {
      200: OrderExportResponseSchema,
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Export order partitions with line items for CSV (flote_admin only)"
  },
  /**
   * Get order partition details including items and customer info.
   */
  getOrderPartitionById: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/:id",
    pathParams: z26.object({ id: z26.string().uuid() }),
    responses: {
      200: AdminPartitionDetailSchema,
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Get order partition details with items (flote_admin only)"
  },
  /**
   * Update an order partition (preparation status, fulfillment type/status, stock location).
   */
  updateOrderPartition: {
    method: "PATCH",
    path: "/api/portal-admin/order-partitions/:id",
    pathParams: z26.object({ id: z26.string().uuid() }),
    body: z26.object({
      preparationStatus: OrderPartitionPreparationStatusSchema.optional(),
      fulfillmentType: OrderPartitionFulfillmentTypeSchema2.optional(),
      fulfillmentStatus: OrderPartitionFulfillmentStatusSchema2.optional(),
      stockLocationId: z26.string().uuid().nullable().optional()
    }),
    responses: {
      200: AdminPartitionListItemSchema,
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Update an order partition (flote_admin only)"
  },
  /**
   * Assign a compliance license to the partition's destination organization location.
   */
  assignDestinationLicense: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:id/destination-license",
    pathParams: z26.object({ id: z26.string().uuid() }),
    body: z26.object({
      complianceLicenseId: z26.string().uuid()
    }),
    responses: {
      200: z26.object({ success: z26.boolean() }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Assign a destination compliance license to a partition (flote_admin only)"
  },
  // ===========================================================================
  // Transfer Template Endpoints (Metrc compliance — 1:1 with partitions)
  // ===========================================================================
  /**
   * Get the transfer template for a partition (if one exists).
   */
  getTransferTemplate: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template",
    pathParams: z26.object({ partitionId: z26.string().uuid() }),
    responses: {
      200: z26.object({
        template: TransferTemplateDtoSchema.nullable(),
        assignedDriverId: z26.string().uuid().nullable()
      }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Get transfer template for partition"
  },
  /**
   * Prepare a Metrc transfer manifest template for a partition.
   * Resolves all compliance data (licenses, driver, packages) and computes readiness.
   * Also assigns the selected driver to the partition for delivery.
   */
  prepareTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/prepare",
    pathParams: z26.object({ partitionId: z26.string().uuid() }),
    body: z26.object({
      driverId: z26.string().uuid(),
      manifestName: z26.string().min(1).optional(),
      transferTypeName: z26.string().min(1).optional(),
      plannedRoute: z26.string().min(1).optional(),
      estimatedDepartureAt: z26.string(),
      estimatedArrivalAt: z26.string(),
      layoverLegs: z26.array(TransferTemplateLayoverLegInputSchema).optional(),
      localLayoverAudit: TransferTemplateLocalLayoverAuditInputSchema.optional()
    }),
    responses: {
      200: z26.object({
        template: TransferTemplateDtoSchema,
        readiness: TransferTemplateReadinessDtoSchema
      }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Prepare transfer template for partition"
  },
  /**
   * Submit a prepared transfer template to Metrc.
   * Template must be in "ready" status.
   */
  submitTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/submit",
    pathParams: z26.object({ partitionId: z26.string().uuid() }),
    body: z26.object({
      expectedVersion: z26.number().int().positive().optional()
    }),
    responses: {
      200: z26.object({ template: TransferTemplateDtoSchema }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Submit transfer template to Metrc"
  },
  /**
   * Update a submitted transfer template on Metrc.
   * Template must be in "submitted" status with a Metrc transfer ID.
   */
  updateTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/update",
    pathParams: z26.object({ partitionId: z26.string().uuid() }),
    body: z26.object({
      expectedVersion: z26.number().int().positive().optional()
    }),
    responses: {
      200: z26.object({ template: TransferTemplateDtoSchema }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Update transfer template on Metrc"
  },
  /**
   * Void a submitted transfer template on Metrc.
   */
  voidTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/void",
    pathParams: z26.object({ partitionId: z26.string().uuid() }),
    body: z26.object({
      expectedVersion: z26.number().int().positive().optional()
    }),
    responses: {
      200: z26.object({ template: TransferTemplateDtoSchema }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Void transfer template on Metrc"
  },
  /**
   * Get compliance status for multiple partitions in a single batch query.
   * Used by Orders page to show compliance readiness badges.
   */
  getTransferTemplateBatchStatus: {
    method: "GET",
    path: "/api/portal-admin/transfer-templates/batch-status",
    query: z26.object({
      partitionIds: z26.string().min(1)
    }),
    responses: {
      200: z26.object({
        statuses: z26.record(z26.string(), TransferTemplateBatchStatusItemSchema)
      }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Get transfer template compliance status for multiple partitions"
  },
  // ===========================================================================
  // Order Creation (supplier portal users with orders:create permission)
  // ===========================================================================
  /**
   * Create an order from the supplier portal.
   * Same partitioning logic as test orders but metadata.isTestOrder = false.
   * TODO(payment): Payment method hardcoded to COD.
   */
  createOrder: {
    method: "POST",
    path: "/api/portal-admin/orders",
    body: CreateTestOrderInputSchema,
    responses: {
      201: TestOrderDetailSchema,
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Create an order (requires orders:create permission)"
  },
  // ===========================================================================
  // Test Order Endpoints
  // ===========================================================================
  createTestOrder: {
    method: "POST",
    path: "/api/portal-admin/test-orders",
    body: CreateTestOrderInputSchema,
    responses: {
      201: TestOrderDetailSchema,
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Create a test order (flote_admin only)"
  },
  listTestOrders: {
    method: "GET",
    path: "/api/portal-admin/test-orders",
    query: z26.object({
      limit: z26.coerce.number().int().positive().max(100).optional().default(25),
      offset: z26.coerce.number().int().nonnegative().optional().default(0)
    }),
    responses: {
      200: TestOrderListResponseSchema,
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "List test orders (flote_admin only)"
  },
  getTestOrder: {
    method: "GET",
    path: "/api/portal-admin/test-orders/:id",
    pathParams: z26.object({ id: z26.string().uuid() }),
    responses: {
      200: TestOrderDetailSchema,
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Get test order detail (flote_admin only)"
  },
  deleteTestOrder: {
    method: "DELETE",
    path: "/api/portal-admin/test-orders/:id",
    pathParams: z26.object({ id: z26.string().uuid() }),
    body: z26.undefined(),
    responses: {
      200: z26.object({ message: z26.string() }),
      400: z26.object({ message: z26.string() }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Delete a test order (flote_admin only)"
  },
  // ===========================================================================
  // Customer Search Endpoint
  // ===========================================================================
  searchCustomers: {
    method: "GET",
    path: "/api/portal-admin/customers/search",
    query: z26.object({
      search: z26.string().min(1),
      limit: z26.coerce.number().int().positive().max(50).optional().default(20)
    }),
    responses: {
      200: z26.object({ customers: z26.array(CustomerSearchResultSchema) }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Search local customers by name or email (flote_admin only)"
  },
  // ===========================================================================
  // Customer Ordering Status Endpoints
  // ===========================================================================
  getCustomerOrderingStatus: {
    method: "GET",
    path: "/api/portal-admin/customers/:customerId/ordering-status",
    pathParams: z26.object({
      customerId: z26.coerce.number().int().positive()
    }),
    responses: {
      200: z26.object({
        customerId: z26.number(),
        companyName: z26.string().nullable(),
        email: z26.string(),
        disableOrdering: z26.boolean()
      }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Get ordering status for a customer (flote_admin only)"
  },
  updateCustomerOrderingStatus: {
    method: "PUT",
    path: "/api/portal-admin/customers/:customerId/ordering-status",
    pathParams: z26.object({
      customerId: z26.coerce.number().int().positive()
    }),
    body: z26.object({
      disableOrdering: z26.boolean()
    }),
    responses: {
      200: z26.object({
        customerId: z26.number(),
        disableOrdering: z26.boolean()
      }),
      401: z26.object({ message: z26.string() }),
      403: z26.object({ message: z26.string() }),
      404: z26.object({ message: z26.string() }),
      500: z26.object({ message: z26.string() })
    },
    summary: "Update ordering status for a customer (flote_admin only)"
  }
});

// src/http/licenses.contract.ts
import { initContract as initContract27 } from "@ts-rest/core";
import { z as z27 } from "zod";
import {
  LicenseDtoSchema,
  CreateLicenseDtoSchema,
  UpdateLicenseDtoSchema,
  LicenseStatusSchema,
  LicenseTypeSchema
} from "@flote/types/compliance";
var c27 = initContract27();
var licensesContract = c27.router({
  list: {
    method: "GET",
    path: "/api/compliance/licenses",
    query: z27.object({
      organizationId: z27.string().uuid().optional(),
      status: LicenseStatusSchema.optional(),
      licenseType: LicenseTypeSchema.optional()
    }),
    responses: {
      200: z27.array(LicenseDtoSchema),
      401: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "List licenses with optional filters"
  },
  getById: {
    method: "GET",
    path: "/api/compliance/licenses/:id",
    pathParams: z27.object({ id: z27.string().uuid() }),
    responses: {
      200: LicenseDtoSchema,
      401: z27.object({ message: z27.string() }),
      404: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Get a license by ID"
  },
  create: {
    method: "POST",
    path: "/api/compliance/licenses",
    body: CreateLicenseDtoSchema,
    responses: {
      201: LicenseDtoSchema,
      400: z27.object({ message: z27.string() }),
      401: z27.object({ message: z27.string() }),
      422: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Create a new license"
  },
  update: {
    method: "PATCH",
    path: "/api/compliance/licenses/:id",
    pathParams: z27.object({ id: z27.string().uuid() }),
    body: UpdateLicenseDtoSchema,
    responses: {
      200: LicenseDtoSchema,
      400: z27.object({ message: z27.string() }),
      401: z27.object({ message: z27.string() }),
      404: z27.object({ message: z27.string() }),
      422: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Update an existing license"
  },
  delete: {
    method: "DELETE",
    path: "/api/compliance/licenses/:id",
    pathParams: z27.object({ id: z27.string().uuid() }),
    body: c27.noBody(),
    responses: {
      204: z27.void(),
      401: z27.object({ message: z27.string() }),
      404: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Soft-delete a license"
  }
});

// src/http/promotions.contract.ts
import { initContract as initContract28 } from "@ts-rest/core";
import { z as z28 } from "zod";
import { BrandPromotionSpotlightDtoSchema } from "@flote/types/promotion";
var c28 = initContract28();
var promotionsContract = c28.router({
  getSpotlight: {
    method: "GET",
    path: "/api/promotions/spotlight",
    query: z28.object({ domain: z28.string().optional() }).optional(),
    responses: {
      200: BrandPromotionSpotlightDtoSchema.nullable(),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get a randomly-selected active brand spotlight promotion"
  }
});

// src/http/organizations.contract.ts
import { initContract as initContract29 } from "@ts-rest/core";
import { z as z29 } from "zod";
import {
  OrganizationDtoSchema,
  OrganizationWithMembershipDtoSchema,
  OrganizationMemberDtoSchema,
  OrganizationLocationDtoSchema,
  OrganizationBankAccountDtoSchema,
  CreateOrganizationDtoSchema,
  UpdateOrganizationDtoSchema,
  CreateOrganizationLocationDtoSchema,
  UpdateOrganizationLocationDtoSchema,
  CreateOrganizationBankAccountDtoSchema,
  AddMemberDtoSchema,
  UpdateMemberRoleDtoSchema,
  OrganizationTypeSchema,
  OrgBrandWithDetailsDtoSchema,
  MemberStockLocationDtoSchema,
  MemberBrandDtoSchema,
  ScopeModeSchema,
  OnboardMemberDtoSchema,
  OnboardMemberResponseDtoSchema
} from "@flote/types/organization";
import {
  ProductStatusSchema,
  ProductTypeFilterSchema,
  ProductRealmSchema as ProductRealmSchema3,
  SupplierProductListingResponseSchema,
  ProductInventoryResponseSchema,
  ProductReservationsResponseSchema,
  BrandInventorySummaryResponseSchema,
  BrandProductInventoryResponseSchema,
  CreateProductInputSchema,
  CreatedProductDtoSchema,
  ProductCreationErrorSchema
} from "@flote/types/product";
import {
  StockLocationDetailDtoSchema as StockLocationDetailDtoSchema3,
  OrgBrandMetrcImportContextDtoSchema,
  StockLocationBrandAssignmentDtoSchema,
  UpdateStockLocationBrandAssignmentsDtoSchema,
  TransferListingResponseSchema as TransferListingResponseSchema2,
  InventoryTransferListingDtoSchema as InventoryTransferListingDtoSchema2,
  CreateInventoryTransferInputSchema as CreateInventoryTransferInputSchema2,
  UpdateTransferStatusInputSchema as UpdateTransferStatusInputSchema2,
  InventoryListingResponseSchema as InventoryListingResponseSchema2,
  CreateOrgStockLocationInputSchema,
  MetrcCsvImportInputSchema,
  MetrcCsvImportResponseSchema
} from "@flote/types/inventory";
var c29 = initContract29();
var organizationsMeContract = c29.router({
  getMyOrganization: {
    method: "GET",
    path: "/api/organizations/me",
    responses: {
      200: OrganizationWithMembershipDtoSchema,
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get the authenticated customer's organization and membership"
  },
  getMyMembers: {
    method: "GET",
    path: "/api/organizations/me/members",
    responses: {
      200: z29.array(OrganizationMemberDtoSchema),
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List members of the authenticated customer's organization"
  },
  getMyLocations: {
    method: "GET",
    path: "/api/organizations/me/locations",
    responses: {
      200: z29.array(OrganizationLocationDtoSchema),
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List locations (shipping destinations) for the authenticated customer's organization"
  },
  createMyLocation: {
    method: "POST",
    path: "/api/organizations/me/locations",
    body: CreateOrganizationLocationDtoSchema,
    responses: {
      201: OrganizationLocationDtoSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Create a location (org admin only)"
  },
  updateMyLocation: {
    method: "PUT",
    path: "/api/organizations/me/locations/:locationId",
    pathParams: z29.object({ locationId: z29.string().uuid() }),
    body: UpdateOrganizationLocationDtoSchema,
    responses: {
      200: OrganizationLocationDtoSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update a location (org admin only)"
  },
  deleteMyLocation: {
    method: "DELETE",
    path: "/api/organizations/me/locations/:locationId",
    pathParams: z29.object({ locationId: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Delete a location (org admin only)"
  },
  getMyBankAccounts: {
    method: "GET",
    path: "/api/organizations/me/bank-accounts",
    responses: {
      200: z29.array(OrganizationBankAccountDtoSchema),
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List shared bank accounts for the authenticated customer's organization"
  },
  createMyBankAccount: {
    method: "POST",
    path: "/api/organizations/me/bank-accounts",
    body: CreateOrganizationBankAccountDtoSchema,
    responses: {
      201: OrganizationBankAccountDtoSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Add a shared bank account (org admin only)"
  },
  deleteMyBankAccount: {
    method: "DELETE",
    path: "/api/organizations/me/bank-accounts/:bankAccountId",
    pathParams: z29.object({ bankAccountId: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Remove a shared bank account (org admin only)"
  }
});
var organizationsAdminContract = c29.router({
  list: {
    method: "GET",
    path: "/api/admin/organizations",
    query: z29.object({
      type: OrganizationTypeSchema.optional(),
      isActive: z29.coerce.boolean().optional(),
      search: z29.string().optional()
    }),
    responses: {
      200: z29.array(OrganizationDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List all organizations (admin)"
  },
  create: {
    method: "POST",
    path: "/api/admin/organizations",
    body: CreateOrganizationDtoSchema,
    responses: {
      201: OrganizationDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Create a new organization (admin)"
  },
  getById: {
    method: "GET",
    path: "/api/admin/organizations/:id",
    pathParams: z29.object({ id: z29.string().uuid() }),
    responses: {
      200: OrganizationDtoSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get organization by ID (admin)"
  },
  update: {
    method: "PUT",
    path: "/api/admin/organizations/:id",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: UpdateOrganizationDtoSchema,
    responses: {
      200: OrganizationDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update an organization (admin)"
  },
  deactivate: {
    method: "DELETE",
    path: "/api/admin/organizations/:id",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Deactivate an organization (admin)"
  },
  getMembers: {
    method: "GET",
    path: "/api/admin/organizations/:id/members",
    pathParams: z29.object({ id: z29.string().uuid() }),
    responses: {
      200: z29.array(OrganizationMemberDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List members of an organization (admin)"
  },
  addMember: {
    method: "POST",
    path: "/api/admin/organizations/:id/members",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: AddMemberDtoSchema,
    responses: {
      201: OrganizationMemberDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      409: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Add a member to an organization (admin)"
  },
  removeMember: {
    method: "DELETE",
    path: "/api/admin/organizations/:id/members/:memberId",
    pathParams: z29.object({ id: z29.string().uuid(), memberId: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Remove a member from an organization (admin)"
  },
  updateMemberRole: {
    method: "PUT",
    path: "/api/admin/organizations/:id/members/:memberId/role",
    pathParams: z29.object({ id: z29.string().uuid(), memberId: z29.string().uuid() }),
    body: UpdateMemberRoleDtoSchema,
    responses: {
      200: OrganizationMemberDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update a member's role (admin)"
  },
  getLocations: {
    method: "GET",
    path: "/api/admin/organizations/:id/locations",
    pathParams: z29.object({ id: z29.string().uuid() }),
    responses: {
      200: z29.array(OrganizationLocationDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List locations for an organization (admin)"
  },
  createLocation: {
    method: "POST",
    path: "/api/admin/organizations/:id/locations",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: CreateOrganizationLocationDtoSchema,
    responses: {
      201: OrganizationLocationDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Add a location to an organization (admin)"
  },
  getOrgBrands: {
    method: "GET",
    path: "/api/admin/organizations/:id/brands",
    pathParams: z29.object({ id: z29.string().uuid() }),
    responses: {
      200: z29.array(OrgBrandWithDetailsDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List brands assigned to an organization (admin)"
  },
  addOrgBrand: {
    method: "PUT",
    path: "/api/admin/organizations/:id/brands/:brandId",
    pathParams: z29.object({ id: z29.string().uuid(), brandId: z29.string().uuid() }),
    body: z29.object({}),
    responses: {
      200: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      409: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Assign a brand to an organization (admin)"
  },
  removeOrgBrand: {
    method: "DELETE",
    path: "/api/admin/organizations/:id/brands/:brandId",
    pathParams: z29.object({ id: z29.string().uuid(), brandId: z29.string().uuid() }),
    body: z29.object({}),
    responses: {
      200: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Remove a brand from an organization (admin)"
  },
  onboardMember: {
    method: "POST",
    path: "/api/admin/organizations/:id/members/onboard",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: OnboardMemberDtoSchema,
    responses: {
      201: OnboardMemberResponseDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      409: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Create a portal user and org member in one step (admin)"
  }
});
var organizationsPortalContract = c29.router({
  getOrgBrands: {
    method: "GET",
    path: "/api/organizations/:orgId/brands",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    responses: {
      200: z29.array(OrgBrandWithDetailsDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get brands associated with an organization (portal auth)"
  },
  getOrgBrandMetrcImportContext: {
    method: "GET",
    path: "/api/organizations/:orgId/brands/:brandId/metrc-import-context",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      brandId: z29.string().uuid()
    }),
    responses: {
      200: OrgBrandMetrcImportContextDtoSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Resolve METRC import context for an org brand (portal auth)"
  },
  getOrgStockLocationBrandAssignments: {
    method: "GET",
    path: "/api/organizations/:orgId/stock-locations/:locationId/brand-assignments",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      locationId: z29.string().uuid()
    }),
    responses: {
      200: z29.array(StockLocationBrandAssignmentDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get brand assignments for an org stock location (portal auth)"
  },
  updateOrgStockLocationBrandAssignments: {
    method: "PUT",
    path: "/api/organizations/:orgId/stock-locations/:locationId/brand-assignments",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      locationId: z29.string().uuid()
    }),
    body: UpdateStockLocationBrandAssignmentsDtoSchema,
    responses: {
      200: z29.array(StockLocationBrandAssignmentDtoSchema),
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update brand assignments for an org stock location (portal auth)"
  },
  getMemberStockLocations: {
    method: "GET",
    path: "/api/organizations/:orgId/members/:memberId/stock-locations",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      memberId: z29.string().uuid()
    }),
    responses: {
      200: z29.array(MemberStockLocationDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get stock locations accessible to a member (portal auth)"
  },
  getOrgStockLocations: {
    method: "GET",
    path: "/api/organizations/:orgId/stock-locations",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    responses: {
      200: z29.array(StockLocationDetailDtoSchema3),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get stock locations accessible to current member with full details"
  },
  createOrgStockLocation: {
    method: "POST",
    path: "/api/organizations/:orgId/stock-locations",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    body: CreateOrgStockLocationInputSchema,
    responses: {
      201: StockLocationDetailDtoSchema3,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Create a stock location within an organization (portal auth)"
  },
  // =========================================================================
  // Member brand access
  // =========================================================================
  getMemberBrands: {
    method: "GET",
    path: "/api/organizations/:orgId/members/:memberId/brands",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      memberId: z29.string().uuid()
    }),
    responses: {
      200: z29.array(MemberBrandDtoSchema),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get brand access records for a member (portal auth)"
  },
  grantMemberBrandAccess: {
    method: "PUT",
    path: "/api/organizations/:orgId/members/:memberId/brands/:brandId",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      memberId: z29.string().uuid(),
      brandId: z29.string().uuid()
    }),
    body: z29.object({
      canView: z29.boolean().optional(),
      canEdit: z29.boolean().optional()
    }),
    responses: {
      200: MemberBrandDtoSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Grant a member access to a brand (portal auth, MEMBERS_MANAGE)"
  },
  revokeMemberBrandAccess: {
    method: "DELETE",
    path: "/api/organizations/:orgId/members/:memberId/brands/:brandId",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      memberId: z29.string().uuid(),
      brandId: z29.string().uuid()
    }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Revoke a member's access to a brand (portal auth, MEMBERS_MANAGE)"
  },
  updateMemberScope: {
    method: "PATCH",
    path: "/api/organizations/:orgId/members/:memberId/scope",
    pathParams: z29.object({
      orgId: z29.string().uuid(),
      memberId: z29.string().uuid()
    }),
    body: z29.object({
      brandScopeMode: ScopeModeSchema.optional(),
      locationScopeMode: ScopeModeSchema.optional()
    }),
    responses: {
      200: z29.object({
        id: z29.string(),
        brandScopeMode: ScopeModeSchema,
        locationScopeMode: ScopeModeSchema
      }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update a member's brand/location scope modes (portal auth, MEMBERS_MANAGE)"
  },
  // =========================================================================
  // Org-scoped product and inventory endpoints
  // =========================================================================
  getOrgProducts: {
    method: "GET",
    path: "/api/organizations/:orgId/products",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    query: z29.object({
      page: z29.coerce.number().int().positive().optional().default(1),
      pageSize: z29.coerce.number().int().positive().max(100).optional().default(25),
      status: ProductStatusSchema.optional(),
      search: z29.string().optional(),
      brandId: z29.string().uuid().optional(),
      excludeLocationId: z29.string().uuid().optional(),
      productType: ProductTypeFilterSchema.optional(),
      realm: ProductRealmSchema3.optional()
    }),
    responses: {
      200: SupplierProductListingResponseSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get paginated products for an organization (portal auth)"
  },
  getOrgProductInventory: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/inventory",
    pathParams: z29.object({ orgId: z29.string().uuid(), productId: z29.string().uuid() }),
    responses: {
      200: ProductInventoryResponseSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get product inventory across org-accessible locations (portal auth)"
  },
  getOrgProductReservations: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/reservations",
    pathParams: z29.object({ orgId: z29.string().uuid(), productId: z29.string().uuid() }),
    query: z29.object({
      locationId: z29.string().uuid().optional()
    }),
    responses: {
      200: ProductReservationsResponseSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get active inventory reservations for a product (portal auth)"
  },
  getOrgBrandInventorySummaries: {
    method: "GET",
    path: "/api/organizations/:orgId/brands/inventory",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    responses: {
      200: BrandInventorySummaryResponseSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get brand-level inventory summaries for an organization (portal auth)"
  },
  getOrgBrandProductInventory: {
    method: "GET",
    path: "/api/organizations/:orgId/brands/:brandId/product-inventory",
    pathParams: z29.object({ orgId: z29.string().uuid(), brandId: z29.string().uuid() }),
    query: z29.object({
      page: z29.coerce.number().int().positive().optional().default(1),
      pageSize: z29.coerce.number().int().positive().max(100).optional().default(25),
      search: z29.string().optional()
    }),
    responses: {
      200: BrandProductInventoryResponseSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get products with inventory for a brand within an organization (portal auth)"
  },
  // =========================================================================
  // Org-scoped transfer endpoints
  // =========================================================================
  getOrgTransfers: {
    method: "GET",
    path: "/api/organizations/:orgId/transfers",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    query: z29.object({
      stockLocationId: z29.string().uuid().optional(),
      productId: z29.string().uuid().optional(),
      status: z29.enum(["pending", "in_transit", "completed", "cancelled"]).optional(),
      direction: z29.enum(["incoming", "outgoing", "all"]).optional().default("all"),
      page: z29.coerce.number().int().positive().optional().default(1),
      pageSize: z29.coerce.number().int().positive().max(100).optional().default(25)
    }),
    responses: {
      200: TransferListingResponseSchema2,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List inventory transfers for member within an organization (portal auth)"
  },
  getOrgTransfer: {
    method: "GET",
    path: "/api/organizations/:orgId/transfers/:transferId",
    pathParams: z29.object({ orgId: z29.string().uuid(), transferId: z29.string().uuid() }),
    responses: {
      200: InventoryTransferListingDtoSchema2,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get a single inventory transfer (portal auth)"
  },
  createOrgTransfer: {
    method: "POST",
    path: "/api/organizations/:orgId/transfers",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    body: CreateInventoryTransferInputSchema2,
    responses: {
      201: InventoryTransferListingDtoSchema2,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      422: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Create an inventory transfer within an organization (portal auth)"
  },
  updateOrgTransferStatus: {
    method: "PATCH",
    path: "/api/organizations/:orgId/transfers/:transferId/status",
    pathParams: z29.object({ orgId: z29.string().uuid(), transferId: z29.string().uuid() }),
    body: UpdateTransferStatusInputSchema2,
    responses: {
      200: InventoryTransferListingDtoSchema2,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      409: z29.object({ message: z29.string() }),
      422: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update transfer status within an organization (portal auth)"
  },
  // =========================================================================
  // Org-scoped product mutation endpoints
  // =========================================================================
  createOrgProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    body: CreateProductInputSchema,
    responses: {
      201: CreatedProductDtoSchema,
      400: ProductCreationErrorSchema,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      422: ProductCreationErrorSchema,
      500: z29.object({ message: z29.string() })
    },
    summary: "Create a new product within an organization (portal auth)"
  },
  deactivateOrgProduct: {
    method: "DELETE",
    path: "/api/organizations/:orgId/products/:productId",
    pathParams: z29.object({ orgId: z29.string().uuid(), productId: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      502: z29.object({ message: z29.string() })
    },
    summary: "Deactivate a product within an organization (portal auth)"
  },
  reactivateOrgProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/reactivate",
    pathParams: z29.object({ orgId: z29.string().uuid(), productId: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      502: z29.object({ message: z29.string() })
    },
    summary: "Reactivate a product within an organization (portal auth)"
  },
  publishOrgProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/publish",
    pathParams: z29.object({ orgId: z29.string().uuid(), productId: z29.string().uuid() }),
    body: c29.noBody(),
    responses: {
      200: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      409: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Publish a draft product within an organization (portal auth)"
  },
  // =========================================================================
  // Metrc CSV Import
  // =========================================================================
  importMetrcCsv: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/metrc-csv-import",
    pathParams: z29.object({ orgId: z29.string().uuid(), productId: z29.string().uuid() }),
    body: MetrcCsvImportInputSchema,
    responses: {
      200: MetrcCsvImportResponseSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      422: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Import Metrc CSV data to update product inventory (portal auth)"
  },
  // =========================================================================
  // Org-Scoped Inventory Endpoints
  // =========================================================================
  // =========================================================================
  // Transporter license management
  // =========================================================================
  setTransporterLicense: {
    method: "POST",
    path: "/api/organizations/:orgId/transporter-license",
    pathParams: z29.object({ orgId: z29.string().uuid() }),
    body: z29.object({ licenseNumber: z29.string().min(1) }),
    responses: {
      200: OrganizationDtoSchema,
      400: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Set the transporter license for an organization (portal auth)"
  },
  getOrgStockLocationInventory: {
    method: "GET",
    path: "/api/organizations/:orgId/stock-locations/:locationId/inventory",
    pathParams: z29.object({ orgId: z29.string().uuid(), locationId: z29.string().uuid() }),
    query: z29.object({
      brandId: z29.string().uuid().optional(),
      search: z29.string().optional(),
      productType: ProductTypeFilterSchema.optional(),
      page: z29.coerce.number().int().min(1).default(1),
      pageSize: z29.coerce.number().int().min(1).max(100).default(50)
    }),
    responses: {
      200: InventoryListingResponseSchema2,
      401: z29.object({ message: z29.string() }),
      403: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get inventory at a stock location filtered by org brands (portal auth)"
  }
});

// src/http/metrc.contract.ts
import { initContract as initContract30 } from "@ts-rest/core";
import { z as z30 } from "zod";
var c30 = initContract30();
var MetrcItemCategoryDtoSchema = z30.object({
  name: z30.string().nullable(),
  productCategoryType: z30.string().nullable(),
  quantityType: z30.string().nullable(),
  requiresStrain: z30.boolean().nullable(),
  requiresItemBrand: z30.boolean().nullable(),
  requiresAdministrationMethod: z30.boolean().nullable(),
  requiresUnitCbdPercent: z30.boolean().nullable(),
  requiresUnitCbdContent: z30.boolean().nullable(),
  requiresUnitThcPercent: z30.boolean().nullable(),
  requiresUnitThcContent: z30.boolean().nullable(),
  requiresUnitVolume: z30.boolean().nullable(),
  requiresUnitWeight: z30.boolean().nullable(),
  requiresServingSize: z30.boolean().nullable(),
  requiresSupplyDurationDays: z30.boolean().nullable(),
  requiresNumberOfDoses: z30.boolean().nullable(),
  requiresIngredients: z30.boolean().nullable(),
  requiresDescription: z30.boolean().nullable()
});
var MetrcStrainDtoSchema = z30.object({
  id: z30.number(),
  name: z30.string().nullable(),
  testingStatus: z30.string().nullable(),
  thcLevel: z30.number().nullable(),
  cbdLevel: z30.number().nullable(),
  indicaPercentage: z30.number(),
  sativaPercentage: z30.number(),
  isUsed: z30.boolean(),
  genetics: z30.string().nullable()
});
var MetrcItemDtoSchema = z30.object({
  id: z30.number(),
  name: z30.string().nullable(),
  productCategoryName: z30.string().nullable(),
  productCategoryType: z30.string().nullable(),
  quantityType: z30.string().nullable(),
  unitOfMeasureName: z30.string().nullable(),
  approvalStatus: z30.string().nullable(),
  strainId: z30.number().nullable(),
  strainName: z30.string().nullable(),
  unitThcPercent: z30.number().nullable(),
  unitCbdPercent: z30.number().nullable(),
  unitWeight: z30.number().nullable(),
  unitWeightUnitOfMeasureName: z30.string().nullable(),
  isUsed: z30.boolean().nullable(),
  /** Whether this item is active in Metrc (false = deactivated but may still have active packages) */
  isActive: z30.boolean()
});
var MetrcUnitOfMeasureDtoSchema = z30.object({
  name: z30.string(),
  quantityType: z30.string().nullable(),
  abbreviation: z30.string().nullable()
});
var MetrcFacilityLicenseDtoSchema = z30.object({
  licenseNumber: z30.string(),
  facilityName: z30.string().nullable(),
  displayName: z30.string().nullable(),
  isOwner: z30.boolean(),
  isManager: z30.boolean()
});
var ErrorResponseSchema2 = z30.object({ message: z30.string() });
var LicenseNumberQuerySchema = z30.object({
  licenseNumber: z30.string().min(1)
});
var metrcReferenceContract = c30.router({
  /** List METRC facilities/licenses available to the authenticated API user */
  listFacilities: {
    method: "GET",
    path: "/api/metrc/facilities",
    responses: {
      200: z30.array(MetrcFacilityLicenseDtoSchema),
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "List METRC facilities/licenses"
  },
  /** List METRC item categories for a license */
  listItemCategories: {
    method: "GET",
    path: "/api/metrc/item-categories",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z30.array(MetrcItemCategoryDtoSchema),
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "List METRC item categories"
  },
  /** List METRC strains for a license */
  listStrains: {
    method: "GET",
    path: "/api/metrc/strains",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z30.array(MetrcStrainDtoSchema),
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "List METRC strains"
  },
  /** List all facility catalog METRC items (active + inactive) for a license */
  listItems: {
    method: "GET",
    path: "/api/metrc/items",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z30.array(MetrcItemDtoSchema),
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "List METRC catalog items"
  },
  /** Deprecated: list METRC items that currently have active packages for a license */
  listImportableItems: {
    method: "GET",
    path: "/api/metrc/importable-items",
    query: LicenseNumberQuerySchema,
    responses: {
      410: ErrorResponseSchema2
    },
    summary: "Deprecated: use /api/metrc/items for item-catalog imports"
  },
  /** List METRC units of measure for a license */
  listUnitsOfMeasure: {
    method: "GET",
    path: "/api/metrc/units-of-measure",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z30.array(MetrcUnitOfMeasureDtoSchema),
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "List METRC units of measure"
  }
});

// src/http/metrc-integration.contract.ts
import { initContract as initContract31 } from "@ts-rest/core";
import { z as z31 } from "zod";
import {
  MetrcIntegrationStatusSchema,
  MetrcIntegrationFacilitySchema
} from "@flote/types/organization";
var c31 = initContract31();
var StoreMetrcIntegrationBodySchema = z31.object({
  userApiKey: z31.string().min(1, "User API key is required"),
  stateCode: z31.string().min(1).max(4).optional().default("mt")
});
var MetrcIntegrationStatusResponseSchema = z31.object({
  status: MetrcIntegrationStatusSchema,
  stateCode: z31.string(),
  lastValidatedAt: z31.string().datetime().nullable(),
  validationError: z31.string().nullable(),
  accessibleFacilities: z31.array(MetrcIntegrationFacilitySchema),
  configuredAt: z31.string().datetime().nullable()
});
var TestMetrcIntegrationResponseSchema = z31.object({
  valid: z31.boolean(),
  facilities: z31.array(MetrcIntegrationFacilitySchema),
  error: z31.string().optional()
});
var MemberKeyStatusEntrySchema = z31.object({
  memberId: z31.string().uuid(),
  memberName: z31.string().nullable(),
  memberEmail: z31.string().nullable(),
  keyStatus: z31.enum(["active", "pending_validation", "invalid", "revoked", "not_configured"]),
  lastValidatedAt: z31.string().datetime().nullable(),
  configuredAt: z31.string().datetime().nullable()
});
var metrcIntegrationAdminContract = c31.router({
  storeIntegration: {
    method: "POST",
    path: "/api/admin/organizations/:id/metrc-integration",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: StoreMetrcIntegrationBodySchema,
    responses: {
      200: MetrcIntegrationStatusResponseSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Store or update a Metrc User API Key for an organization (admin)"
  },
  testIntegration: {
    method: "POST",
    path: "/api/admin/organizations/:id/metrc-integration/test",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: c31.noBody(),
    responses: {
      200: TestMetrcIntegrationResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Validate the stored Metrc key by fetching facilities (admin)"
  },
  getIntegrationStatus: {
    method: "GET",
    path: "/api/admin/organizations/:id/metrc-integration",
    pathParams: z31.object({ id: z31.string().uuid() }),
    responses: {
      200: MetrcIntegrationStatusResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get the Metrc integration status for an organization (admin)"
  },
  listMemberKeyStatuses: {
    method: "GET",
    path: "/api/admin/organizations/:id/metrc-integration/members",
    pathParams: z31.object({ id: z31.string().uuid() }),
    responses: {
      200: z31.object({ members: z31.array(MemberKeyStatusEntrySchema) }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List all members' Metrc key statuses for an organization (admin)"
  },
  revokeIntegration: {
    method: "DELETE",
    path: "/api/admin/organizations/:id/metrc-integration",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: c31.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Revoke the Metrc integration for an organization (admin)"
  }
});

// src/http/metrc-member-key.contract.ts
import { initContract as initContract32 } from "@ts-rest/core";
import { z as z32 } from "zod";
import {
  MetrcIntegrationStatusSchema as MetrcIntegrationStatusSchema2,
  MetrcIntegrationFacilitySchema as MetrcIntegrationFacilitySchema2
} from "@flote/types/organization";
var c32 = initContract32();
var StoreMyKeyBodySchema = z32.object({
  userApiKey: z32.string().min(1, "User API key is required"),
  stateCode: z32.string().min(1).max(4).optional().default("mt")
});
var MyKeyStatusResponseSchema = z32.object({
  status: MetrcIntegrationStatusSchema2,
  stateCode: z32.string(),
  lastValidatedAt: z32.string().datetime().nullable(),
  validationError: z32.string().nullable(),
  accessibleFacilities: z32.array(MetrcIntegrationFacilitySchema2),
  configuredAt: z32.string().datetime().nullable()
});
var TestMyKeyResponseSchema = z32.object({
  valid: z32.boolean(),
  facilities: z32.array(MetrcIntegrationFacilitySchema2),
  error: z32.string().optional()
});
var metrcMemberKeyContract = c32.router({
  storeMyKey: {
    method: "POST",
    path: "/api/metrc/my-key",
    body: StoreMyKeyBodySchema,
    responses: {
      200: MyKeyStatusResponseSchema,
      401: z32.object({ message: z32.string() }),
      500: z32.object({ message: z32.string() })
    },
    summary: "Store or update the authenticated member's Metrc API key"
  },
  testMyKey: {
    method: "POST",
    path: "/api/metrc/my-key/test",
    body: c32.noBody(),
    responses: {
      200: TestMyKeyResponseSchema,
      401: z32.object({ message: z32.string() }),
      404: z32.object({ message: z32.string() }),
      500: z32.object({ message: z32.string() })
    },
    summary: "Validate the authenticated member's stored Metrc key"
  },
  getMyKeyStatus: {
    method: "GET",
    path: "/api/metrc/my-key",
    responses: {
      200: MyKeyStatusResponseSchema,
      401: z32.object({ message: z32.string() }),
      404: z32.object({ message: z32.string() }),
      500: z32.object({ message: z32.string() })
    },
    summary: "Get the authenticated member's Metrc key status"
  },
  revokeMyKey: {
    method: "DELETE",
    path: "/api/metrc/my-key",
    body: c32.noBody(),
    responses: {
      204: z32.void(),
      401: z32.object({ message: z32.string() }),
      404: z32.object({ message: z32.string() }),
      500: z32.object({ message: z32.string() })
    },
    summary: "Revoke the authenticated member's Metrc key"
  }
});

// src/http/org-products.contract.ts
import { initContract as initContract33 } from "@ts-rest/core";
import { z as z33 } from "zod";
import {
  BulkCreateProductsInputSchema,
  BulkCreateProductsResponseSchema,
  LinkedMetrcItemIdsResponseSchema
} from "@flote/types/product";
var c33 = initContract33();
var ErrorResponseSchema3 = z33.object({ message: z33.string() });
var orgProductsContract = c33.router({
  bulkCreateOrgProducts: {
    method: "POST",
    path: "/api/organizations/:orgId/products/bulk",
    pathParams: z33.object({ orgId: z33.string().uuid() }),
    body: BulkCreateProductsInputSchema,
    responses: {
      200: BulkCreateProductsResponseSchema,
      400: ErrorResponseSchema3,
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "Bulk create products within an organization"
  },
  getLinkedMetrcItemIds: {
    method: "GET",
    path: "/api/organizations/:orgId/products/linked-metrc-item-ids",
    pathParams: z33.object({ orgId: z33.string().uuid() }),
    responses: {
      200: LinkedMetrcItemIdsResponseSchema,
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "Get Metrc item IDs already linked to products in this org"
  }
});

// src/http/supplier-analytics.contract.ts
import { initContract as initContract34 } from "@ts-rest/core";
import { z as z34 } from "zod";
var c34 = initContract34();
var DateRangeQuerySchema = z34.object({
  fromDate: z34.string().describe("ISO date string (YYYY-MM-DD)"),
  toDate: z34.string().describe("ISO date string (YYYY-MM-DD)")
}).refine(
  (data) => new Date(data.toDate) >= new Date(data.fromDate),
  { message: "toDate must be on or after fromDate" }
).refine(
  (data) => {
    const from = new Date(data.fromDate);
    const to = new Date(data.toDate);
    const diffDays = (to.getTime() - from.getTime()) / (1e3 * 60 * 60 * 24);
    return diffDays <= 366;
  },
  { message: "Date range must not exceed 366 days" }
);
var GranularitySchema = z34.enum(["day", "week", "month"]);
var SortBySchema = z34.enum(["revenue", "quantity"]);
var TopProductSummarySchema = z34.object({
  productName: z34.string(),
  sku: z34.string().nullable(),
  totalRevenue: z34.number(),
  totalQuantity: z34.number().int()
});
var TopCustomerSummarySchema = z34.object({
  buyerOrganizationId: z34.string().nullable(),
  buyerName: z34.string(),
  totalRevenue: z34.number(),
  orderCount: z34.number().int()
});
var AnalyticsSummaryResponseSchema = z34.object({
  totalRevenue: z34.number(),
  revenueChange: z34.number(),
  totalOrders: z34.number().int(),
  ordersChange: z34.number(),
  averageOrderValue: z34.number(),
  aovChange: z34.number(),
  topProducts: z34.array(TopProductSummarySchema),
  topCustomers: z34.array(TopCustomerSummarySchema),
  period: z34.object({
    from: z34.string(),
    to: z34.string()
  })
});
var OrderTimeBucketSchema = z34.object({
  period: z34.string(),
  orderCount: z34.number().int(),
  revenue: z34.number(),
  averageOrderValue: z34.number()
});
var PeriodSummarySchema = z34.object({
  totalOrders: z34.number().int(),
  totalRevenue: z34.number(),
  averageOrderValue: z34.number()
});
var OrdersOverTimeResponseSchema = z34.object({
  buckets: z34.array(OrderTimeBucketSchema),
  summary: PeriodSummarySchema,
  priorPeriod: PeriodSummarySchema
});
var ProductSalesRowSchema = z34.object({
  productId: z34.string(),
  productName: z34.string(),
  variantTitle: z34.string().nullable(),
  sku: z34.string().nullable(),
  brandName: z34.string().nullable(),
  totalQuantity: z34.number().int(),
  totalRevenue: z34.number(),
  orderCount: z34.number().int()
});
var ProductSalesResponseSchema = z34.object({
  products: z34.array(ProductSalesRowSchema)
});
var CustomerSalesRowSchema = z34.object({
  buyerOrganizationId: z34.string().nullable(),
  buyerName: z34.string(),
  orderCount: z34.number().int(),
  totalRevenue: z34.number(),
  totalQuantity: z34.number().int(),
  firstOrderDate: z34.string().nullable(),
  lastOrderDate: z34.string().nullable(),
  daysSinceLastOrder: z34.number().int().nullable()
});
var SalesByCustomerResponseSchema = z34.object({
  customers: z34.array(CustomerSalesRowSchema)
});
var FulfillmentTypeSummarySchema = z34.object({
  fulfillmentType: z34.string(),
  orderCount: z34.number().int(),
  revenue: z34.number(),
  fees: z34.number(),
  effectiveRate: z34.number()
});
var FulfillmentEconomicsBucketSchema = z34.object({
  period: z34.string(),
  byType: z34.array(FulfillmentTypeSummarySchema)
});
var FulfillmentEconomicsTotalsSchema = z34.object({
  totalRevenue: z34.number(),
  totalFees: z34.number(),
  effectiveRate: z34.number(),
  selfDeliverySavings: z34.number()
});
var FulfillmentEconomicsResponseSchema = z34.object({
  buckets: z34.array(FulfillmentEconomicsBucketSchema),
  summary: FulfillmentEconomicsTotalsSchema,
  priorPeriod: FulfillmentEconomicsTotalsSchema
});
var RetentionBuyerSchema = z34.object({
  buyerOrganizationId: z34.string().nullable(),
  buyerName: z34.string(),
  firstOrderDate: z34.string(),
  lastOrderDate: z34.string(),
  totalOrders: z34.number().int(),
  totalRevenue: z34.number(),
  daysSinceLastOrder: z34.number().int(),
  status: z34.enum(["active", "at_risk", "churned"])
});
var RetentionMonthlyBreakdownSchema = z34.object({
  period: z34.string(),
  newBuyerRevenue: z34.number(),
  returningBuyerRevenue: z34.number(),
  newBuyerCount: z34.number().int(),
  returningBuyerCount: z34.number().int()
});
var RetentionSummarySchema = z34.object({
  totalBuyers: z34.number().int(),
  repeatBuyers: z34.number().int(),
  repeatRate: z34.number(),
  newBuyers: z34.number().int(),
  churnedBuyers: z34.number().int()
});
var CustomerRetentionResponseSchema = z34.object({
  summary: RetentionSummarySchema,
  buyers: z34.array(RetentionBuyerSchema),
  monthlyBreakdown: z34.array(RetentionMonthlyBreakdownSchema)
});
var BrandComparisonEntrySchema = z34.object({
  brandId: z34.string(),
  brandName: z34.string(),
  revenue: z34.number(),
  orders: z34.number().int(),
  averageOrderValue: z34.number(),
  unitsSold: z34.number().int(),
  avgFulfillmentHours: z34.number().nullable(),
  selfDeliveryPct: z34.number(),
  topProductName: z34.string().nullable()
});
var BrandComparisonSummarySchema = z34.object({
  activeBrands: z34.number().int(),
  topBrandName: z34.string().nullable(),
  topBrandRevenue: z34.number(),
  revenueConcentration: z34.number()
});
var BrandComparisonResponseSchema = z34.object({
  summary: BrandComparisonSummarySchema,
  brands: z34.array(BrandComparisonEntrySchema)
});
var ErrorResponseSchema4 = z34.object({ message: z34.string() });
var supplierAnalyticsContract = c34.router({
  getSummary: {
    method: "GET",
    path: "/api/supplier/analytics/summary",
    query: z34.object({
      periodDays: z34.coerce.number().int().positive().max(366).optional().default(30),
      brandId: z34.string().uuid().optional()
    }),
    responses: {
      200: AnalyticsSummaryResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get analytics summary for the dashboard (last 30 days with period-over-period change)"
  },
  getOrdersOverTime: {
    method: "GET",
    path: "/api/supplier/analytics/orders-over-time",
    query: z34.object({
      fromDate: z34.string(),
      toDate: z34.string(),
      granularity: GranularitySchema.optional().default("month"),
      brandId: z34.string().uuid().optional()
    }),
    responses: {
      200: OrdersOverTimeResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get orders over time with configurable granularity"
  },
  getProductSales: {
    method: "GET",
    path: "/api/supplier/analytics/product-sales",
    query: z34.object({
      fromDate: z34.string(),
      toDate: z34.string(),
      limit: z34.coerce.number().int().positive().max(100).optional().default(25),
      sortBy: SortBySchema.optional().default("revenue"),
      brandId: z34.string().uuid().optional()
    }),
    responses: {
      200: ProductSalesResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get top products by revenue or quantity sold"
  },
  getSalesByCustomer: {
    method: "GET",
    path: "/api/supplier/analytics/sales-by-customer",
    query: z34.object({
      fromDate: z34.string(),
      toDate: z34.string(),
      limit: z34.coerce.number().int().positive().max(100).optional().default(25),
      brandId: z34.string().uuid().optional()
    }),
    responses: {
      200: SalesByCustomerResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get sales breakdown by buyer organization"
  },
  getCustomerRetention: {
    method: "GET",
    path: "/api/supplier/analytics/customer-retention",
    query: z34.object({
      fromDate: z34.string(),
      toDate: z34.string(),
      brandId: z34.string().uuid().optional()
    }),
    responses: {
      200: CustomerRetentionResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get customer retention metrics and buyer health"
  },
  getFulfillmentEconomics: {
    method: "GET",
    path: "/api/supplier/analytics/fulfillment-economics",
    query: z34.object({
      fromDate: z34.string(),
      toDate: z34.string(),
      granularity: GranularitySchema.optional().default("month"),
      brandId: z34.string().uuid().optional()
    }),
    responses: {
      200: FulfillmentEconomicsResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get fulfillment economics breakdown by delivery method"
  },
  getBrandComparison: {
    method: "GET",
    path: "/api/supplier/analytics/brand-comparison",
    query: z34.object({
      fromDate: z34.string(),
      toDate: z34.string()
    }),
    responses: {
      200: BrandComparisonResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Compare performance across brands (no brand filter \u2014 compares all)"
  }
});

// src/http/customer-capabilities.contract.ts
import { initContract as initContract35 } from "@ts-rest/core";
import { z as z35 } from "zod";
import { AllowedPaymentMethodsSchema } from "@flote/types/customer-capabilities";
var c35 = initContract35();
var BrandPaymentCapabilitiesDtoSchema = z35.object({
  customerId: z35.number().int().positive(),
  brandId: z35.string().uuid(),
  allowedPaymentMethods: AllowedPaymentMethodsSchema,
  /** true if a brand-specific override is set; false if using the global default */
  isOverride: z35.boolean()
});
var UpdateBrandPaymentCapabilitiesBodySchema = z35.object({
  allowedPaymentMethods: AllowedPaymentMethodsSchema
});
var customerCapabilitiesContract = c35.router({
  getForCustomer: {
    method: "GET",
    path: "/api/supplier/customers/:customerId/payment-capabilities",
    pathParams: z35.object({
      customerId: z35.coerce.number().int().positive()
    }),
    responses: {
      200: BrandPaymentCapabilitiesDtoSchema,
      400: z35.object({ message: z35.string() }),
      401: z35.object({ message: z35.string() }),
      403: z35.object({ message: z35.string() }),
      404: z35.object({ message: z35.string() }),
      500: z35.object({ message: z35.string() })
    },
    summary: "Get brand-scoped payment capabilities for a customer"
  },
  updateForCustomer: {
    method: "PUT",
    path: "/api/supplier/customers/:customerId/payment-capabilities",
    pathParams: z35.object({
      customerId: z35.coerce.number().int().positive()
    }),
    body: UpdateBrandPaymentCapabilitiesBodySchema,
    responses: {
      200: BrandPaymentCapabilitiesDtoSchema,
      400: z35.object({ message: z35.string() }),
      401: z35.object({ message: z35.string() }),
      403: z35.object({ message: z35.string() }),
      404: z35.object({ message: z35.string() }),
      500: z35.object({ message: z35.string() })
    },
    summary: "Set brand-scoped payment methods for a customer"
  }
});

// src/http/index.ts
var c36 = initContract36();
var commerceHttpRoutes = {
  analytics: analyticsContract,
  brands: brandsContract,
  products: productsContract,
  productSync: productSyncContract,
  categories: categoriesContract,
  orders: ordersContract,
  customers: customersContract,
  addresses: addressesContract,
  checkout: checkoutContract,
  bankAccounts: bankAccountsContract,
  scheduledChecks: scheduledChecksContract,
  discountCodes: discountCodesContract,
  fulfillmentOffers: fulfillmentOffersContract,
  transactions: transactionsContract,
  promotions: promotionsContract,
  licenses: licensesContract,
  b2bwaveBrands: b2bwaveBrandsContract,
  metrcReference: metrcReferenceContract,
  orgProducts: orgProductsContract
};
var authHttpRoutes = {
  embedConfig: embedConfigContract,
  auth: authContract,
  portalAuth: portalAuthContract,
  email: emailContract,
  permissions: permissionsContract
};
var organizationHttpRoutes = {
  inventory: inventoryContract,
  inventoryAccess: inventoryAccessContract,
  productManagement: productManagementContract,
  portalAdmin: portalAdminContract,
  organizationsMe: organizationsMeContract,
  organizationsAdmin: organizationsAdminContract,
  organizationsPortal: organizationsPortalContract,
  metrcIntegrationAdmin: metrcIntegrationAdminContract,
  metrcMemberKey: metrcMemberKeyContract,
  supplierAnalytics: supplierAnalyticsContract,
  customerCapabilities: customerCapabilitiesContract
};
var operationsHttpRoutes = {
  signnow: signnowContract,
  telnyx: telnyxContract,
  assignmentQueue: assignmentQueueContract,
  drivers: supplierDriversContract,
  deliveryTeam: supplierDeliveryTeamContract,
  vehicles: supplierVehiclesContract,
  deliveryRoutes: supplierRoutesContract,
  supplierShipmentLegs: shipmentLegsContract,
  routePlans: supplierRoutePlansContract
};
var rootHttpRoutes = {
  ...commerceHttpRoutes,
  ...authHttpRoutes,
  ...organizationHttpRoutes,
  ...operationsHttpRoutes
};
var rootHttpContract = c36.router(rootHttpRoutes);
var commerceHttpContract = c36.router(commerceHttpRoutes);
var authHttpContract = c36.router(authHttpRoutes);
var organizationHttpContract = c36.router(organizationHttpRoutes);
var operationsHttpContract = c36.router(operationsHttpRoutes);
var legacyRootHttpContract = rootHttpContract;
var modularHttpContractGroups = {
  commerce: commerceHttpContract,
  auth: authHttpContract,
  organization: organizationHttpContract,
  operations: operationsHttpContract
};
export {
  AbortOptimizationResponseSchema,
  AccessibleEmbedSchema,
  AddDeliveryTeamManagerRequestSchema,
  AddHubSplitRequestSchema,
  AddHubSplitResponseSchema,
  AdminOrderPartitionDetailSchema,
  AdminOrderPartitionSchema,
  AdminPartitionDetailSchema,
  AdminPartitionFulfillmentStatusSchema,
  AdminPartitionFulfillmentTypeSchema,
  AdminPartitionItemBatchAllocationSchema,
  AdminPartitionItemDetailSchema,
  AdminPartitionItemSchema,
  AdminPartitionListItemSchema,
  AdminPartitionListResponseSchema,
  AdminProductListingDtoSchema,
  AdminProductListingResponseSchema,
  AdminStockLocationDtoSchema,
  AdminStockLocationListResponseSchema,
  AnalyticsBatchEventSchema,
  AnalyticsBatchRequestSchema,
  AnalyticsCaptureEventSchema,
  AnalyticsErrorResponseSchema,
  AnalyticsGroupIdentifySchema,
  AnalyticsIdentifySchema,
  AnalyticsSuccessResponseSchema,
  AnalyticsSummaryResponseSchema,
  AssignDestinationLicenseRequestSchema,
  AssignDestinationLicenseResponseSchema,
  AssignDriverToPartitionRequestSchema,
  AssignDriverToShipmentLegRequestSchema,
  AssignDriverToShipmentLegResponseSchema,
  AssignTaskRequestSchema,
  AssignVehicleRequestSchema,
  AssignVehicleToDriverRequestSchema,
  AuthCustomerSchema,
  AuthValidationResponseSchema,
  AutoEnqueueRequestSchema,
  AutoEnqueueResponseSchema,
  B2BWaveCategoryDtoSchema,
  B2BWaveOrderProductSummarySchema,
  B2BWaveOrderSummarySchema,
  B2BWaveProductCustomerPriceDtoSchema,
  B2BWaveProductDtoSchema,
  B2BWaveProductFileDtoSchema,
  B2BWaveProductPriceDtoSchema,
  B2BWaveProductVariantOptionSchema,
  B2BWaveProductVariantSchema,
  B2BWaveWarehouseQuantitySchema,
  BankAccountDtoSchema,
  BatchInsertHubRequestSchema,
  BatchInsertHubResponseSchema,
  BatchRoutesResponseSchema,
  BrandComparisonResponseSchema,
  BrandPaymentCapabilitiesDtoSchema,
  CancelQueueEntryResponseSchema,
  CheckCarrierTrackingMetricsSchema,
  CheckCarrierTrackingResponseSchema,
  CompletionRequirementsSchema,
  CreateAuxiliaryTaskBodySchema,
  CreateAuxiliaryTaskResponseSchema,
  CreateDestinationAddressSchema,
  CreateDestinationRequestSchema,
  CreateDriverRequestSchema,
  CreateDriverVehicleInputSchema,
  CreateHubAddressSchema,
  CreateHubRequestSchema,
  CreateLinkedTasksRequestSchema,
  CreateOnfleetWebhookRequestSchema,
  CreatePartitionTaskRequestSchema,
  CreateRecipientRequestSchema,
  CreateRoutePlanInputSchema,
  CreateShipmentFromPartitionsRequestSchema,
  CreateShipmentFromPartitionsResponseSchema,
  CreateShipmentPlanQueueErrorSchema,
  CreateShipmentPlanRequestSchema,
  CreateShipmentPlanResponseSchema,
  CreateSupplierDriverInputSchema,
  CreateSupplierLocationTeamRequestSchema,
  CreateSupplierVehicleInputSchema,
  CreateTaskRequestSchema,
  CreateTeamRequestSchema,
  CreateTestOrderInputSchema,
  CreateTestOrderItemSchema,
  CreateVehicleRequestSchema,
  CreditApplicationSchema,
  CustomerRetentionResponseSchema,
  CustomerSearchResultSchema,
  DashboardStatsSchema,
  DeleteShipmentLegRequestSchema,
  DeleteShipmentLegResponseSchema,
  DeleteShipmentRequestSchema,
  DeleteShipmentResponseSchema,
  DeliveryTaskSchema,
  DeliveryTaskStatusSchema,
  DeliveryTaskTypeSchema,
  DeliveryTeamHubOptionSchema,
  DeliveryTeamManagerSchema,
  DestinationAddressSchema,
  DestinationLocationSchema,
  DestinationSchema,
  DispatchShipmentRequestSchema,
  DriverAnalyticsQuerySchema,
  DriverAnalyticsSchema,
  DriverPoolQuerySchema,
  DriverPoolResponseSchema,
  DriverPositionSchema,
  DriverReconcileMetricsSchema,
  DriverSchema,
  DriverStatusSchema,
  DriverTasksQuerySchema,
  EmbedBrandingSchema,
  EmbedConfigResponseSchema,
  EnqueuePartitionRequestSchema,
  EnqueuePartitionResponseSchema,
  EnrichedB2BWaveProductSchema,
  EnrichedQueueEntrySchema,
  FileAttachmentSchema,
  FulfillmentEconomicsResponseSchema,
  GeoLocationSchema,
  GetAssignmentQueueStatsQuerySchema,
  GetB2BWaveCategoriesInputDtoSchema,
  GetB2BWaveCustomersInputDtoSchema,
  GetB2BWaveProductCustomerPricesInputDtoSchema,
  GetB2BWaveProductsInputDtoSchema,
  GetRoutesQuerySchema,
  GetShipmentDriverPositionsResponseSchema,
  GetShipmentLegManifestResponseSchema,
  GetSupplierRoutesQuerySchema,
  GetTeamTasksQuerySchema,
  HubAddressSchema,
  HubLocationSchema,
  HubSchema,
  InitializeOptimizationRequestSchema,
  InitializeOptimizationResponseSchema,
  InsertWaypointRequestSchema,
  InsertWaypointResponseSchema,
  InternalDatabaseFailoverStatusResponseSchema,
  InternalDatabaseFailoverSwitchResponseSchema,
  InternalDatabaseHealthSchema,
  InternalDatabaseStatusSchema,
  InternalDatabaseSwitchRequestSchema,
  InternalDatabaseSwitchResultSchema,
  LegConsistencyIssueSchema,
  LinkedTasksResponseSchema,
  ListAssignmentQueueQuerySchema,
  ListDestinationsQuerySchema,
  ListDriversQuerySchema,
  ListOrdersQuerySchema,
  ListPartitionsQuerySchema,
  ListRecipientsQuerySchema,
  ListRoutePlansQuerySchema,
  ListShipmentLegQueueQuerySchema,
  ListShipmentSummariesQuerySchema,
  ListSupplierDriversQuerySchema,
  ListSupplierVehiclesQuerySchema,
  ListTasksQuerySchema,
  ListVehiclesQuerySchema,
  MemberSchema,
  MetrcFacilityLicenseDtoSchema,
  MetrcItemCategoryDtoSchema,
  MetrcItemDtoSchema,
  MetrcStrainDtoSchema,
  MetrcUnitOfMeasureDtoSchema,
  OnfleetWebhookSchema,
  OnfleetWebhookTriggerSchema,
  OptimizationIssueSchema,
  OptimizationMetricsSchema,
  OptimizationResultSummarySchema,
  OptimizationStatusResponseSchema,
  OptimizationWorkerMetricsSchema,
  OrderExportResponseSchema,
  OrderExportRowSchema,
  OrdersOverTimeResponseSchema,
  PaginatedPartitionsResponseSchema,
  PartitionTaskResultSchema,
  PartitionTaskSkippedSchema,
  PhotoUploadResponseSchema,
  PollDriverLocationRequestSchema,
  PollDriverLocationResponseSchema,
  PortalBrandSchema,
  PortalUserRoleSchema,
  PortalUserSchema,
  PrepareShipmentLegManifestRequestSchema,
  PrepareShipmentLegManifestResponseSchema,
  PrepareShipmentManifestsRequestSchema,
  PrepareShipmentManifestsResponseSchema,
  ProductSalesResponseSchema,
  PublicTrackingResponseSchema,
  QueueListResponseSchema,
  RecipientSchema,
  RecipientSearchQuerySchema,
  ReconcileDriversResponseSchema,
  ReconcileFulfillmentsMetricsSchema,
  ReconcileFulfillmentsRequestSchema,
  ReconcileFulfillmentsResponseSchema,
  ReconcileShipmentLegMetrcRefsRequestSchema,
  ReconcileShipmentLegMetrcRefsResponseSchema,
  ReconcileShipmentLegMetrcRefsScopeSchema,
  RemoveHubSplitRequestSchema,
  RemoveHubSplitResponseSchema,
  ReorderStopsRequestSchema,
  ReorderStopsResponseSchema,
  ResendCreateEmailResponseSchema,
  RouteBoundsSchema,
  RouteOptimizationModeSchema,
  RouteOptimizationParamsSchema,
  RoutePlanSchema,
  RoutePlanSummarySchema,
  RoutePointSchema,
  SalesByCustomerResponseSchema,
  SendVerificationRequestSchema,
  SendVerificationResponseSchema,
  SetDefaultBankAccountRequestSchema,
  ShipmentDetailResponseSchema,
  ShipmentLegManifestActionResponseSchema,
  ShipmentLegQueueListResponseSchema,
  ShipmentManifestActionResponseSchema,
  ShipmentQueueSummariesResponseSchema,
  SignNowDocumentGroupTemplateSchema,
  SignNowDocumentGroupTemplatesResponseSchema,
  SignNowEmbeddedInviteLinkSchema,
  SignNowSigningLinkSchema,
  SignNowTemplateSchema,
  SignNowThumbnailSchema,
  StoreBankAccountRequestSchema,
  SubmitShipmentLegManifestRequestSchema,
  SubmitShipmentManifestRequestSchema,
  SupplierDeliveryTeamSchema,
  SupplierLocationTeamSchema,
  SupplierLocationTeamWithDetailsSchema,
  SyncDeliveryProofAssetRequestSchema,
  SyncDeliveryProofAssetResponseSchema,
  SyncResponseSchema,
  SyncTeamResultSchema,
  TaskAddressSchema,
  TaskAssignmentResultSchema,
  TaskRouteSchema,
  TeamAutoDispatchRequestSchema,
  TeamAutoDispatchResponseSchema,
  TeamMembersSchema,
  TeamSchema,
  TelnyxErrorSchema,
  TestOrderDetailSchema,
  TestOrderListItemSchema,
  TestOrderListResponseSchema,
  TimelineEntrySchema,
  UpdateBrandPaymentCapabilitiesBodySchema,
  UpdateDriverRequestSchema,
  UpdateDriverTeamsInputSchema,
  UpdateHubMetadataRequestSchema,
  UpdateHubMetadataResponseSchema,
  UpdateHubRequestSchema,
  UpdatePartitionRequestSchema,
  UpdatePriorityRequestSchema,
  UpdateRecipientRequestSchema,
  UpdateRoutePlanTasksInputSchema,
  UpdateShipmentLegManifestRequestSchema,
  UpdateShipmentLegRequestSchema,
  UpdateShipmentLegResponseSchema,
  UpdateSupplierDeliveryTeamRequestSchema,
  UpdateSupplierDriverInputSchema,
  UpdateSupplierVehicleInputSchema,
  UpdateTaskRequestSchema,
  UpdateTeamRequestSchema,
  UpdateVehicleRequestSchema,
  VehicleSchema,
  VehicleStatusSchema,
  VehicleTypeSchema,
  VerifyCodeRequestSchema,
  VerifyCodeResponseSchema,
  VoidShipmentLegManifestRequestSchema,
  addressesContract,
  adminAuthContract,
  adminDashboardContract,
  adminDestinationsContract,
  adminDriversContract,
  adminHubsContract,
  adminOnfleetWebhooksContract,
  adminOrdersContract,
  adminPartitionsContract,
  adminRecipientsContract,
  adminRouteOptimizationContract,
  adminRoutesContract,
  adminTasksContract,
  adminTeamsContract,
  adminVehiclesContract,
  analyticsContract,
  assignmentQueueContract,
  authContract,
  authHttpContract,
  authHttpRoutes,
  auxiliaryTasksContract,
  b2bwaveBrandsContract,
  bankAccountsContract,
  brandsContract,
  categoriesContract,
  checkoutContract,
  commerceHttpContract,
  commerceHttpRoutes,
  customerCapabilitiesContract,
  customersContract,
  deliveryGatewayContract,
  discountCodesContract,
  emailContract,
  embedConfigContract,
  fulfillmentOffersContract,
  internalAssignmentQueueContract,
  internalDatabaseFailoverContract,
  internalPartitionTasksContract,
  inventoryAccessContract,
  inventoryContract,
  jobsContract,
  legacyRootHttpContract,
  licensesContract,
  metrcIntegrationAdminContract,
  metrcMemberKeyContract,
  metrcReferenceContract,
  modularHttpContractGroups,
  operationsHttpContract,
  operationsHttpRoutes,
  ordersContract,
  orgProductsContract,
  organizationHttpContract,
  organizationHttpRoutes,
  organizationsAdminContract,
  organizationsMeContract,
  organizationsPortalContract,
  permissionsContract,
  portalAdminContract,
  portalAuthContract,
  productManagementContract,
  productSyncContract,
  productsContract,
  promotionsContract,
  rootHttpContract,
  rootHttpRoutes,
  scheduledChecksContract,
  shipmentLegsContract,
  signnowContract,
  supplierAnalyticsContract,
  supplierDeliveryTeamContract,
  supplierDriversContract,
  supplierRoutePlansContract,
  supplierRoutesContract,
  supplierVehiclesContract,
  telnyxContract,
  trackingContract,
  transactionsContract,
  webhooksContract
};
